// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/organization.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { CountRequest, CountResponse } from "./count_pb";
import { file_gitpod_v1_count } from "./count_pb";
import type { KernelControlsAction } from "./environment_pb";
import { file_gitpod_v1_environment } from "./environment_pb";
import type { PaginationRequest, PaginationResponse, SortOrder } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { UserStatus } from "./user_pb";
import { file_gitpod_v1_user } from "./user_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/organization.proto.
 */
export const file_gitpod_v1_organization: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_count, file_gitpod_v1_environment, file_gitpod_v1_pagination, file_gitpod_v1_user, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.UpdateOrganizationRequest
 */
export type UpdateOrganizationRequest = Message<"gitpod.v1.UpdateOrganizationRequest"> & {
  /**
   * organization_id is the ID of the organization to update the settings for.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * name is the new name of the organization
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * invite_domains is the domain allowlist of the organization
   *
   * @generated from field: optional gitpod.v1.InviteDomains invite_domains = 3;
   */
  inviteDomains?: InviteDomains;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationRequest.
 * Use `create(UpdateOrganizationRequestSchema)` to create a new message.
 */
export const UpdateOrganizationRequestSchema: GenMessage<UpdateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 0);

/**
 * @generated from message gitpod.v1.UpdateOrganizationResponse
 */
export type UpdateOrganizationResponse = Message<"gitpod.v1.UpdateOrganizationResponse"> & {
  /**
   * organization is the updated organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationResponse.
 * Use `create(UpdateOrganizationResponseSchema)` to create a new message.
 */
export const UpdateOrganizationResponseSchema: GenMessage<UpdateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 1);

/**
 * @generated from message gitpod.v1.CreateOrganizationRequest
 */
export type CreateOrganizationRequest = Message<"gitpod.v1.CreateOrganizationRequest"> & {
  /**
   * name is the organization name
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * join_organization decides whether the Identity issuing this request joins the org on creation
   *
   * @generated from field: bool join_organization = 2;
   */
  joinOrganization: boolean;

  /**
   * Should other Accounts with the same domain be automatically invited to the organization?
   *
   * @generated from field: bool invite_accounts_with_matching_domain = 3;
   */
  inviteAccountsWithMatchingDomain: boolean;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationRequest.
 * Use `create(CreateOrganizationRequestSchema)` to create a new message.
 */
export const CreateOrganizationRequestSchema: GenMessage<CreateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 2);

/**
 * @generated from message gitpod.v1.CreateOrganizationResponse
 */
export type CreateOrganizationResponse = Message<"gitpod.v1.CreateOrganizationResponse"> & {
  /**
   * organization is the created organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * member is the member that joined the org on creation. Only set if specified "join_organization" is "true" in the request.
   *
   * @generated from field: gitpod.v1.OrganizationMember member = 2;
   */
  member?: OrganizationMember;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationResponse.
 * Use `create(CreateOrganizationResponseSchema)` to create a new message.
 */
export const CreateOrganizationResponseSchema: GenMessage<CreateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 3);

/**
 * @generated from message gitpod.v1.JoinOrganizationRequest
 */
export type JoinOrganizationRequest = Message<"gitpod.v1.JoinOrganizationRequest"> & {
  /**
   * @generated from oneof gitpod.v1.JoinOrganizationRequest.join_id
   */
  joinId: {
    /**
     * organization_id is the unique identifier of the Organization to join.
     *
     * @generated from field: string organization_id = 1;
     */
    value: string;
    case: "organizationId";
  } | {
    /**
     * invite_id is the unique identifier of the invite to join the organization.
     *
     * @generated from field: string invite_id = 2;
     */
    value: string;
    case: "inviteId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.JoinOrganizationRequest.
 * Use `create(JoinOrganizationRequestSchema)` to create a new message.
 */
export const JoinOrganizationRequestSchema: GenMessage<JoinOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 4);

/**
 * @generated from message gitpod.v1.JoinOrganizationResponse
 */
export type JoinOrganizationResponse = Message<"gitpod.v1.JoinOrganizationResponse"> & {
  /**
   * member is the member that was created by joining the organization.
   *
   * @generated from field: gitpod.v1.OrganizationMember member = 1;
   */
  member?: OrganizationMember;
};

/**
 * Describes the message gitpod.v1.JoinOrganizationResponse.
 * Use `create(JoinOrganizationResponseSchema)` to create a new message.
 */
export const JoinOrganizationResponseSchema: GenMessage<JoinOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 5);

/**
 * @generated from message gitpod.v1.LeaveOrganizationRequest
 */
export type LeaveOrganizationRequest = Message<"gitpod.v1.LeaveOrganizationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message gitpod.v1.LeaveOrganizationRequest.
 * Use `create(LeaveOrganizationRequestSchema)` to create a new message.
 */
export const LeaveOrganizationRequestSchema: GenMessage<LeaveOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 6);

/**
 * @generated from message gitpod.v1.LeaveOrganizationResponse
 */
export type LeaveOrganizationResponse = Message<"gitpod.v1.LeaveOrganizationResponse"> & {
};

/**
 * Describes the message gitpod.v1.LeaveOrganizationResponse.
 * Use `create(LeaveOrganizationResponseSchema)` to create a new message.
 */
export const LeaveOrganizationResponseSchema: GenMessage<LeaveOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 7);

/**
 * @generated from message gitpod.v1.GetOrganizationRequest
 */
export type GetOrganizationRequest = Message<"gitpod.v1.GetOrganizationRequest"> & {
  /**
   * organization_id is the unique identifier of the Organization to retreive.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetOrganizationRequest.
 * Use `create(GetOrganizationRequestSchema)` to create a new message.
 */
export const GetOrganizationRequestSchema: GenMessage<GetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 8);

/**
 * @generated from message gitpod.v1.GetOrganizationResponse
 */
export type GetOrganizationResponse = Message<"gitpod.v1.GetOrganizationResponse"> & {
  /**
   * organization is the requested organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message gitpod.v1.GetOrganizationResponse.
 * Use `create(GetOrganizationResponseSchema)` to create a new message.
 */
export const GetOrganizationResponseSchema: GenMessage<GetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 9);

/**
 * @generated from message gitpod.v1.DeleteOrganizationRequest
 */
export type DeleteOrganizationRequest = Message<"gitpod.v1.DeleteOrganizationRequest"> & {
  /**
   * organization_id is the ID of the organization to delete
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteOrganizationRequest.
 * Use `create(DeleteOrganizationRequestSchema)` to create a new message.
 */
export const DeleteOrganizationRequestSchema: GenMessage<DeleteOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 10);

/**
 * @generated from message gitpod.v1.DeleteOrganizationResponse
 */
export type DeleteOrganizationResponse = Message<"gitpod.v1.DeleteOrganizationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteOrganizationResponse.
 * Use `create(DeleteOrganizationResponseSchema)` to create a new message.
 */
export const DeleteOrganizationResponseSchema: GenMessage<DeleteOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 11);

/**
 * @generated from message gitpod.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"gitpod.v1.ListMembersRequest"> & {
  /**
   * pagination contains the pagination options for listing members
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * organization_id is the ID of the organization to list members for
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: gitpod.v1.ListMembersRequest.Filter filter = 3;
   */
  filter?: ListMembersRequest_Filter;

  /**
   * sort specifies the order of results. When unspecified, the authenticated user is
   * returned first, followed by other members sorted by name ascending. When an explicit
   * sort is specified, results are sorted purely by the requested field without any
   * special handling for the authenticated user.
   *
   * @generated from field: gitpod.v1.ListMembersRequest.Sort sort = 4;
   */
  sort?: ListMembersRequest_Sort;

  /**
   * count controls whether the response includes a bounded total count.
   *
   * @generated from field: gitpod.v1.CountRequest count = 5;
   */
  count?: CountRequest;
};

/**
 * Describes the message gitpod.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 12);

/**
 * @generated from message gitpod.v1.ListMembersRequest.Filter
 */
export type ListMembersRequest_Filter = Message<"gitpod.v1.ListMembersRequest.Filter"> & {
  /**
   * search performs case-insensitive search across member name and email
   *
   * @generated from field: string search = 1;
   */
  search: string;

  /**
   * status filters members by their user status
   *
   * @generated from field: repeated gitpod.v1.UserStatus statuses = 2;
   */
  statuses: UserStatus[];

  /**
   * roles filters members by their organization role
   *
   * @generated from field: repeated gitpod.v1.OrganizationRole roles = 3;
   */
  roles: OrganizationRole[];

  /**
   * user_ids filters the response to only members with the specified user IDs
   *
   * @generated from field: repeated string user_ids = 4;
   */
  userIds: string[];

  /**
   * exclude_group_ids excludes members who are already in any of the specified groups
   *
   * @generated from field: repeated string exclude_group_ids = 5;
   */
  excludeGroupIds: string[];

  /**
   * exclude_members_in_any_team excludes members who belong to any team in the organization
   *
   * @generated from field: bool exclude_members_in_any_team = 6;
   */
  excludeMembersInAnyTeam: boolean;
};

/**
 * Describes the message gitpod.v1.ListMembersRequest.Filter.
 * Use `create(ListMembersRequest_FilterSchema)` to create a new message.
 */
export const ListMembersRequest_FilterSchema: GenMessage<ListMembersRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 12, 0);

/**
 * @generated from message gitpod.v1.ListMembersRequest.Sort
 */
export type ListMembersRequest_Sort = Message<"gitpod.v1.ListMembersRequest.Sort"> & {
  /**
   * @generated from field: gitpod.v1.ListMembersRequest.SortField field = 1;
   */
  field: ListMembersRequest_SortField;

  /**
   * @generated from field: gitpod.v1.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message gitpod.v1.ListMembersRequest.Sort.
 * Use `create(ListMembersRequest_SortSchema)` to create a new message.
 */
export const ListMembersRequest_SortSchema: GenMessage<ListMembersRequest_Sort> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 12, 1);

/**
 * @generated from enum gitpod.v1.ListMembersRequest.SortField
 */
export enum ListMembersRequest_SortField {
  /**
   * @generated from enum value: SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort by member's display name
   *
   * @generated from enum value: SORT_FIELD_NAME = 1;
   */
  NAME = 1,

  /**
   * Sort by the date the member joined the organization
   *
   * @generated from enum value: SORT_FIELD_DATE_JOINED = 2;
   */
  DATE_JOINED = 2,
}

/**
 * Describes the enum gitpod.v1.ListMembersRequest.SortField.
 */
export const ListMembersRequest_SortFieldSchema: GenEnum<ListMembersRequest_SortField> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 12, 0);

/**
 * @generated from message gitpod.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"gitpod.v1.ListMembersResponse"> & {
  /**
   * pagination contains the pagination options for listing members
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * members are the members of the organization
   *
   * @generated from field: repeated gitpod.v1.OrganizationMember members = 2;
   */
  members: OrganizationMember[];

  /**
   * count is the bounded total count of matching members, present only when
   * requested via CountRequest.include on the first page.
   *
   * @generated from field: gitpod.v1.CountResponse count = 3;
   */
  count?: CountResponse;
};

/**
 * Describes the message gitpod.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 13);

/**
 * @generated from message gitpod.v1.SetRoleRequest
 */
export type SetRoleRequest = Message<"gitpod.v1.SetRoleRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: gitpod.v1.OrganizationRole role = 3;
   */
  role: OrganizationRole;
};

/**
 * Describes the message gitpod.v1.SetRoleRequest.
 * Use `create(SetRoleRequestSchema)` to create a new message.
 */
export const SetRoleRequestSchema: GenMessage<SetRoleRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 14);

/**
 * @generated from message gitpod.v1.SetRoleResponse
 */
export type SetRoleResponse = Message<"gitpod.v1.SetRoleResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetRoleResponse.
 * Use `create(SetRoleResponseSchema)` to create a new message.
 */
export const SetRoleResponseSchema: GenMessage<SetRoleResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 15);

/**
 * @generated from message gitpod.v1.GetOrganizationInviteRequest
 */
export type GetOrganizationInviteRequest = Message<"gitpod.v1.GetOrganizationInviteRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetOrganizationInviteRequest.
 * Use `create(GetOrganizationInviteRequestSchema)` to create a new message.
 */
export const GetOrganizationInviteRequestSchema: GenMessage<GetOrganizationInviteRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 16);

/**
 * @generated from message gitpod.v1.GetOrganizationInviteResponse
 */
export type GetOrganizationInviteResponse = Message<"gitpod.v1.GetOrganizationInviteResponse"> & {
  /**
   * @generated from field: gitpod.v1.OrganizationInvite invite = 1;
   */
  invite?: OrganizationInvite;
};

/**
 * Describes the message gitpod.v1.GetOrganizationInviteResponse.
 * Use `create(GetOrganizationInviteResponseSchema)` to create a new message.
 */
export const GetOrganizationInviteResponseSchema: GenMessage<GetOrganizationInviteResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 17);

/**
 * @generated from message gitpod.v1.OrganizationInvite
 */
export type OrganizationInvite = Message<"gitpod.v1.OrganizationInvite"> & {
  /**
   * invite_id is the unique identifier of the invite to join the organization.
   * Use JoinOrganization with this ID to join the organization.
   *
   * @generated from field: string invite_id = 1;
   */
  inviteId: string;
};

/**
 * Describes the message gitpod.v1.OrganizationInvite.
 * Use `create(OrganizationInviteSchema)` to create a new message.
 */
export const OrganizationInviteSchema: GenMessage<OrganizationInvite> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 18);

/**
 * @generated from message gitpod.v1.CreateOrganizationInviteRequest
 */
export type CreateOrganizationInviteRequest = Message<"gitpod.v1.CreateOrganizationInviteRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationInviteRequest.
 * Use `create(CreateOrganizationInviteRequestSchema)` to create a new message.
 */
export const CreateOrganizationInviteRequestSchema: GenMessage<CreateOrganizationInviteRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 19);

/**
 * @generated from message gitpod.v1.CreateOrganizationInviteResponse
 */
export type CreateOrganizationInviteResponse = Message<"gitpod.v1.CreateOrganizationInviteResponse"> & {
  /**
   * @generated from field: gitpod.v1.OrganizationInvite invite = 1;
   */
  invite?: OrganizationInvite;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationInviteResponse.
 * Use `create(CreateOrganizationInviteResponseSchema)` to create a new message.
 */
export const CreateOrganizationInviteResponseSchema: GenMessage<CreateOrganizationInviteResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 20);

/**
 * @generated from message gitpod.v1.GetOrganizationInviteSummaryRequest
 */
export type GetOrganizationInviteSummaryRequest = Message<"gitpod.v1.GetOrganizationInviteSummaryRequest"> & {
  /**
   * @generated from field: string invite_id = 1;
   */
  inviteId: string;
};

/**
 * Describes the message gitpod.v1.GetOrganizationInviteSummaryRequest.
 * Use `create(GetOrganizationInviteSummaryRequestSchema)` to create a new message.
 */
export const GetOrganizationInviteSummaryRequestSchema: GenMessage<GetOrganizationInviteSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 21);

/**
 * @generated from message gitpod.v1.GetOrganizationInviteSummaryResponse
 */
export type GetOrganizationInviteSummaryResponse = Message<"gitpod.v1.GetOrganizationInviteSummaryResponse"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: int32 organization_member_count = 3;
   */
  organizationMemberCount: number;
};

/**
 * Describes the message gitpod.v1.GetOrganizationInviteSummaryResponse.
 * Use `create(GetOrganizationInviteSummaryResponseSchema)` to create a new message.
 */
export const GetOrganizationInviteSummaryResponseSchema: GenMessage<GetOrganizationInviteSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 22);

/**
 * @generated from message gitpod.v1.Organization
 */
export type Organization = Message<"gitpod.v1.Organization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: gitpod.v1.InviteDomains invite_domains = 5;
   */
  inviteDomains?: InviteDomains;

  /**
   * The tier of the organization - free, enterprise or core
   *
   * @generated from field: gitpod.v1.OrganizationTier tier = 6;
   */
  tier: OrganizationTier;
};

/**
 * Describes the message gitpod.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 23);

/**
 * @generated from message gitpod.v1.OrganizationMember
 */
export type OrganizationMember = Message<"gitpod.v1.OrganizationMember"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: gitpod.v1.OrganizationRole role = 2;
   */
  role: OrganizationRole;

  /**
   * @generated from field: google.protobuf.Timestamp member_since = 3;
   */
  memberSince?: Timestamp;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: string full_name = 5;
   */
  fullName: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: gitpod.v1.UserStatus status = 7;
   */
  status: UserStatus;

  /**
   * login_provider is the login provider the user uses to sign in
   *
   * @generated from field: string login_provider = 8;
   */
  loginProvider: string;
};

/**
 * Describes the message gitpod.v1.OrganizationMember.
 * Use `create(OrganizationMemberSchema)` to create a new message.
 */
export const OrganizationMemberSchema: GenMessage<OrganizationMember> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 24);

/**
 * @generated from message gitpod.v1.InviteDomains
 */
export type InviteDomains = Message<"gitpod.v1.InviteDomains"> & {
  /**
   * domains is the list of domains that are allowed to join the organization
   *
   * @generated from field: repeated string domains = 1;
   */
  domains: string[];
};

/**
 * Describes the message gitpod.v1.InviteDomains.
 * Use `create(InviteDomainsSchema)` to create a new message.
 */
export const InviteDomainsSchema: GenMessage<InviteDomains> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 25);

/**
 * @generated from message gitpod.v1.CreateSSOConfigurationRequest
 */
export type CreateSSOConfigurationRequest = Message<"gitpod.v1.CreateSSOConfigurationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * client_id is the client ID of the OIDC application set on the IdP
   *
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * client_secret is the client secret of the OIDC application set on the IdP
   *
   * @generated from field: string client_secret = 3;
   */
  clientSecret: string;

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: string issuer_url = 4;
   */
  issuerUrl: string;

  /**
   * email_domain is the domain that is allowed to sign in to the organization
   *
   * @generated from field: optional string email_domain = 5;
   */
  emailDomain?: string;

  /**
   * @generated from field: repeated string email_domains = 6;
   */
  emailDomains: string[];

  /**
   * @generated from field: string display_name = 7;
   */
  displayName: string;

  /**
   * additional_scopes are extra OIDC scopes to request from the identity provider during sign-in.
   * These are appended to the default scopes (openid, email, profile).
   *
   * @generated from field: repeated string additional_scopes = 8;
   */
  additionalScopes: string[];

  /**
   * claims_expression is an optional CEL expression evaluated against OIDC token claims during login.
   * When set, the expression must evaluate to true for the login to succeed.
   * Example: `claims.email_verified && claims.email.endsWith("@example.com")`
   *
   * @generated from field: optional string claims_expression = 9;
   */
  claimsExpression?: string;
};

/**
 * Describes the message gitpod.v1.CreateSSOConfigurationRequest.
 * Use `create(CreateSSOConfigurationRequestSchema)` to create a new message.
 */
export const CreateSSOConfigurationRequestSchema: GenMessage<CreateSSOConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 26);

/**
 * @generated from message gitpod.v1.CreateSSOConfigurationResponse
 */
export type CreateSSOConfigurationResponse = Message<"gitpod.v1.CreateSSOConfigurationResponse"> & {
  /**
   * sso_configuration is the created SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfiguration sso_configuration = 1;
   */
  ssoConfiguration?: SSOConfiguration;
};

/**
 * Describes the message gitpod.v1.CreateSSOConfigurationResponse.
 * Use `create(CreateSSOConfigurationResponseSchema)` to create a new message.
 */
export const CreateSSOConfigurationResponseSchema: GenMessage<CreateSSOConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 27);

/**
 * @generated from message gitpod.v1.SSOConfiguration
 */
export type SSOConfiguration = Message<"gitpod.v1.SSOConfiguration"> & {
  /**
   * id is the unique identifier of the SSO configuration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * client_id is the client ID of the OIDC application set on the IdP
   *
   * @generated from field: string client_id = 3;
   */
  clientId: string;

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: string issuer_url = 4;
   */
  issuerUrl: string;

  /**
   * state is the state of the SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfigurationState state = 5;
   */
  state: SSOConfigurationState;

  /**
   * claims are key/value pairs that defines a mapping of claims issued by the IdP.
   *
   * @generated from field: map<string, string> claims = 6;
   */
  claims: { [key: string]: string };

  /**
   * @generated from field: string email_domain = 7;
   */
  emailDomain: string;

  /**
   * provider_type defines the type of the SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfiguration.ProviderType provider_type = 8;
   */
  providerType: SSOConfiguration_ProviderType;

  /**
   * @generated from field: repeated string email_domains = 9;
   */
  emailDomains: string[];

  /**
   * @generated from field: string display_name = 10;
   */
  displayName: string;

  /**
   * additional_scopes are extra OIDC scopes requested from the identity provider during sign-in.
   *
   * @generated from field: repeated string additional_scopes = 11;
   */
  additionalScopes: string[];

  /**
   * claims_expression is a CEL (Common Expression Language) expression evaluated against
   * the OIDC token claims during login. When set, the expression must evaluate to true
   * for the login to succeed. The expression has access to a `claims` variable containing
   * all token claims as a map. Example: `claims.email_verified && claims.email.endsWith("@example.com")`
   *
   * @generated from field: string claims_expression = 12;
   */
  claimsExpression: string;
};

/**
 * Describes the message gitpod.v1.SSOConfiguration.
 * Use `create(SSOConfigurationSchema)` to create a new message.
 */
export const SSOConfigurationSchema: GenMessage<SSOConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 28);

/**
 * @generated from enum gitpod.v1.SSOConfiguration.ProviderType
 */
export enum SSOConfiguration_ProviderType {
  /**
   * @generated from enum value: PROVIDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROVIDER_TYPE_BUILTIN = 1;
   */
  BUILTIN = 1,

  /**
   * @generated from enum value: PROVIDER_TYPE_CUSTOM = 2;
   */
  CUSTOM = 2,
}

/**
 * Describes the enum gitpod.v1.SSOConfiguration.ProviderType.
 */
export const SSOConfiguration_ProviderTypeSchema: GenEnum<SSOConfiguration_ProviderType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 28, 0);

/**
 * @generated from message gitpod.v1.GetSSOConfigurationRequest
 */
export type GetSSOConfigurationRequest = Message<"gitpod.v1.GetSSOConfigurationRequest"> & {
  /**
   * sso_configuration_id is the ID of the SSO configuration to get
   *
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId: string;
};

/**
 * Describes the message gitpod.v1.GetSSOConfigurationRequest.
 * Use `create(GetSSOConfigurationRequestSchema)` to create a new message.
 */
export const GetSSOConfigurationRequestSchema: GenMessage<GetSSOConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 29);

/**
 * @generated from message gitpod.v1.GetSSOConfigurationResponse
 */
export type GetSSOConfigurationResponse = Message<"gitpod.v1.GetSSOConfigurationResponse"> & {
  /**
   * sso_configuration is the SSO configuration identified by the ID
   *
   * @generated from field: gitpod.v1.SSOConfiguration sso_configuration = 1;
   */
  ssoConfiguration?: SSOConfiguration;
};

/**
 * Describes the message gitpod.v1.GetSSOConfigurationResponse.
 * Use `create(GetSSOConfigurationResponseSchema)` to create a new message.
 */
export const GetSSOConfigurationResponseSchema: GenMessage<GetSSOConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 30);

/**
 * @generated from message gitpod.v1.ListSSOConfigurationsRequest
 */
export type ListSSOConfigurationsRequest = Message<"gitpod.v1.ListSSOConfigurationsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * organization_id is the ID of the organization to list SSO configurations for.
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.ListSSOConfigurationsRequest.
 * Use `create(ListSSOConfigurationsRequestSchema)` to create a new message.
 */
export const ListSSOConfigurationsRequestSchema: GenMessage<ListSSOConfigurationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 31);

/**
 * @generated from message gitpod.v1.ListSSOConfigurationsResponse
 */
export type ListSSOConfigurationsResponse = Message<"gitpod.v1.ListSSOConfigurationsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * sso_configurations are the SSO configurations for the organization
   *
   * @generated from field: repeated gitpod.v1.SSOConfiguration sso_configurations = 2;
   */
  ssoConfigurations: SSOConfiguration[];
};

/**
 * Describes the message gitpod.v1.ListSSOConfigurationsResponse.
 * Use `create(ListSSOConfigurationsResponseSchema)` to create a new message.
 */
export const ListSSOConfigurationsResponseSchema: GenMessage<ListSSOConfigurationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 32);

/**
 * @generated from message gitpod.v1.UpdateSSOConfigurationRequest
 */
export type UpdateSSOConfigurationRequest = Message<"gitpod.v1.UpdateSSOConfigurationRequest"> & {
  /**
   * sso_configuration_id is the ID of the SSO configuration to update
   *
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId: string;

  /**
   * client_id is the client ID of the SSO provider
   *
   * @generated from field: optional string client_id = 2;
   */
  clientId?: string;

  /**
   * client_secret is the client secret of the SSO provider
   *
   * @generated from field: optional string client_secret = 3;
   */
  clientSecret?: string;

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: optional string issuer_url = 4;
   */
  issuerUrl?: string;

  /**
   * state is the state of the SSO configuration
   *
   * @generated from field: optional gitpod.v1.SSOConfigurationState state = 5;
   */
  state?: SSOConfigurationState;

  /**
   * claims are key/value pairs that defines a mapping of claims issued by the IdP.
   *
   * @generated from field: map<string, string> claims = 6;
   */
  claims: { [key: string]: string };

  /**
   * @generated from field: optional string email_domain = 7;
   */
  emailDomain?: string;

  /**
   * @generated from field: repeated string email_domains = 9;
   */
  emailDomains: string[];

  /**
   * @generated from field: optional string display_name = 10;
   */
  displayName?: string;

  /**
   * additional_scopes replaces the configured OIDC scopes when present.
   * When absent (nil), scopes are left unchanged.
   * When present with an empty scopes list, all additional scopes are cleared.
   *
   * @generated from field: optional gitpod.v1.AdditionalScopesUpdate additional_scopes = 11;
   */
  additionalScopes?: AdditionalScopesUpdate;

  /**
   * claims_expression is a CEL expression evaluated against OIDC token claims during login.
   * When set, the expression must evaluate to true for the login to succeed.
   * When present with an empty string, the expression is cleared.
   *
   * @generated from field: optional string claims_expression = 12;
   */
  claimsExpression?: string;
};

/**
 * Describes the message gitpod.v1.UpdateSSOConfigurationRequest.
 * Use `create(UpdateSSOConfigurationRequestSchema)` to create a new message.
 */
export const UpdateSSOConfigurationRequestSchema: GenMessage<UpdateSSOConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 33);

/**
 * AdditionalScopesUpdate wraps a list of OIDC scopes so that the update request
 * can distinguish "not changing scopes" (field absent) from "clearing all scopes"
 * (field present, empty list).
 *
 * @generated from message gitpod.v1.AdditionalScopesUpdate
 */
export type AdditionalScopesUpdate = Message<"gitpod.v1.AdditionalScopesUpdate"> & {
  /**
   * @generated from field: repeated string scopes = 1;
   */
  scopes: string[];
};

/**
 * Describes the message gitpod.v1.AdditionalScopesUpdate.
 * Use `create(AdditionalScopesUpdateSchema)` to create a new message.
 */
export const AdditionalScopesUpdateSchema: GenMessage<AdditionalScopesUpdate> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 34);

/**
 * @generated from message gitpod.v1.UpdateSSOConfigurationResponse
 */
export type UpdateSSOConfigurationResponse = Message<"gitpod.v1.UpdateSSOConfigurationResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateSSOConfigurationResponse.
 * Use `create(UpdateSSOConfigurationResponseSchema)` to create a new message.
 */
export const UpdateSSOConfigurationResponseSchema: GenMessage<UpdateSSOConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 35);

/**
 * @generated from message gitpod.v1.DeleteSSOConfigurationRequest
 */
export type DeleteSSOConfigurationRequest = Message<"gitpod.v1.DeleteSSOConfigurationRequest"> & {
  /**
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteSSOConfigurationRequest.
 * Use `create(DeleteSSOConfigurationRequestSchema)` to create a new message.
 */
export const DeleteSSOConfigurationRequestSchema: GenMessage<DeleteSSOConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 36);

/**
 * @generated from message gitpod.v1.DeleteSSOConfigurationResponse
 */
export type DeleteSSOConfigurationResponse = Message<"gitpod.v1.DeleteSSOConfigurationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteSSOConfigurationResponse.
 * Use `create(DeleteSSOConfigurationResponseSchema)` to create a new message.
 */
export const DeleteSSOConfigurationResponseSchema: GenMessage<DeleteSSOConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 37);

/**
 * SCIMConfiguration represents a SCIM 2.0 provisioning configuration
 *
 * @generated from message gitpod.v1.SCIMConfiguration
 */
export type SCIMConfiguration = Message<"gitpod.v1.SCIMConfiguration"> & {
  /**
   * id is the unique identifier of the SCIM configuration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * organization_id is the ID of the organization this SCIM configuration belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * enabled indicates if SCIM provisioning is active
   *
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * sso_configuration_id is the linked SSO configuration (optional)
   *
   * @generated from field: string sso_configuration_id = 5;
   */
  ssoConfigurationId: string;

  /**
   * created_at is when the SCIM configuration was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the SCIM configuration was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * token_expires_at is when the current SCIM token expires
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 8;
   */
  tokenExpiresAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.SCIMConfiguration.
 * Use `create(SCIMConfigurationSchema)` to create a new message.
 */
export const SCIMConfigurationSchema: GenMessage<SCIMConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 38);

/**
 * @generated from message gitpod.v1.CreateSCIMConfigurationRequest
 */
export type CreateSCIMConfigurationRequest = Message<"gitpod.v1.CreateSCIMConfigurationRequest"> & {
  /**
   * organization_id is the ID of the organization to create the SCIM configuration for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * sso_configuration_id is the SSO configuration to link (required for user provisioning)
   *
   * @generated from field: string sso_configuration_id = 3;
   */
  ssoConfigurationId: string;

  /**
   * token_expires_in is the duration until the token expires.
   * Defaults to 1 year. Minimum 1 day, maximum 2 years.
   *
   * @generated from field: optional google.protobuf.Duration token_expires_in = 4;
   */
  tokenExpiresIn?: Duration;
};

/**
 * Describes the message gitpod.v1.CreateSCIMConfigurationRequest.
 * Use `create(CreateSCIMConfigurationRequestSchema)` to create a new message.
 */
export const CreateSCIMConfigurationRequestSchema: GenMessage<CreateSCIMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 39);

/**
 * @generated from message gitpod.v1.CreateSCIMConfigurationResponse
 */
export type CreateSCIMConfigurationResponse = Message<"gitpod.v1.CreateSCIMConfigurationResponse"> & {
  /**
   * scim_configuration is the created SCIM configuration
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;

  /**
   * token is the bearer token for SCIM API authentication.
   * This is only returned once during creation - store it securely.
   *
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * token_expires_at is when the token will expire
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 3;
   */
  tokenExpiresAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.CreateSCIMConfigurationResponse.
 * Use `create(CreateSCIMConfigurationResponseSchema)` to create a new message.
 */
export const CreateSCIMConfigurationResponseSchema: GenMessage<CreateSCIMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 40);

/**
 * @generated from message gitpod.v1.GetSCIMConfigurationRequest
 */
export type GetSCIMConfigurationRequest = Message<"gitpod.v1.GetSCIMConfigurationRequest"> & {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to get
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId: string;
};

/**
 * Describes the message gitpod.v1.GetSCIMConfigurationRequest.
 * Use `create(GetSCIMConfigurationRequestSchema)` to create a new message.
 */
export const GetSCIMConfigurationRequestSchema: GenMessage<GetSCIMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 41);

/**
 * @generated from message gitpod.v1.GetSCIMConfigurationResponse
 */
export type GetSCIMConfigurationResponse = Message<"gitpod.v1.GetSCIMConfigurationResponse"> & {
  /**
   * scim_configuration is the SCIM configuration identified by the ID
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;
};

/**
 * Describes the message gitpod.v1.GetSCIMConfigurationResponse.
 * Use `create(GetSCIMConfigurationResponseSchema)` to create a new message.
 */
export const GetSCIMConfigurationResponseSchema: GenMessage<GetSCIMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 42);

/**
 * @generated from message gitpod.v1.ListSCIMConfigurationsRequest
 */
export type ListSCIMConfigurationsRequest = Message<"gitpod.v1.ListSCIMConfigurationsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListSCIMConfigurationsRequest.
 * Use `create(ListSCIMConfigurationsRequestSchema)` to create a new message.
 */
export const ListSCIMConfigurationsRequestSchema: GenMessage<ListSCIMConfigurationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 43);

/**
 * @generated from message gitpod.v1.ListSCIMConfigurationsResponse
 */
export type ListSCIMConfigurationsResponse = Message<"gitpod.v1.ListSCIMConfigurationsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * scim_configurations are the SCIM configurations for the organization
   *
   * @generated from field: repeated gitpod.v1.SCIMConfiguration scim_configurations = 2;
   */
  scimConfigurations: SCIMConfiguration[];
};

/**
 * Describes the message gitpod.v1.ListSCIMConfigurationsResponse.
 * Use `create(ListSCIMConfigurationsResponseSchema)` to create a new message.
 */
export const ListSCIMConfigurationsResponseSchema: GenMessage<ListSCIMConfigurationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 44);

/**
 * @generated from message gitpod.v1.UpdateSCIMConfigurationRequest
 */
export type UpdateSCIMConfigurationRequest = Message<"gitpod.v1.UpdateSCIMConfigurationRequest"> & {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to update
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId: string;

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * enabled controls whether SCIM provisioning is active
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;

  /**
   * sso_configuration_id is the SSO configuration to link
   *
   * @generated from field: optional string sso_configuration_id = 4;
   */
  ssoConfigurationId?: string;
};

/**
 * Describes the message gitpod.v1.UpdateSCIMConfigurationRequest.
 * Use `create(UpdateSCIMConfigurationRequestSchema)` to create a new message.
 */
export const UpdateSCIMConfigurationRequestSchema: GenMessage<UpdateSCIMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 45);

/**
 * @generated from message gitpod.v1.UpdateSCIMConfigurationResponse
 */
export type UpdateSCIMConfigurationResponse = Message<"gitpod.v1.UpdateSCIMConfigurationResponse"> & {
  /**
   * scim_configuration is the updated SCIM configuration
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;
};

/**
 * Describes the message gitpod.v1.UpdateSCIMConfigurationResponse.
 * Use `create(UpdateSCIMConfigurationResponseSchema)` to create a new message.
 */
export const UpdateSCIMConfigurationResponseSchema: GenMessage<UpdateSCIMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 46);

/**
 * @generated from message gitpod.v1.DeleteSCIMConfigurationRequest
 */
export type DeleteSCIMConfigurationRequest = Message<"gitpod.v1.DeleteSCIMConfigurationRequest"> & {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to delete
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteSCIMConfigurationRequest.
 * Use `create(DeleteSCIMConfigurationRequestSchema)` to create a new message.
 */
export const DeleteSCIMConfigurationRequestSchema: GenMessage<DeleteSCIMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 47);

/**
 * @generated from message gitpod.v1.DeleteSCIMConfigurationResponse
 */
export type DeleteSCIMConfigurationResponse = Message<"gitpod.v1.DeleteSCIMConfigurationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteSCIMConfigurationResponse.
 * Use `create(DeleteSCIMConfigurationResponseSchema)` to create a new message.
 */
export const DeleteSCIMConfigurationResponseSchema: GenMessage<DeleteSCIMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 48);

/**
 * @generated from message gitpod.v1.RegenerateSCIMTokenRequest
 */
export type RegenerateSCIMTokenRequest = Message<"gitpod.v1.RegenerateSCIMTokenRequest"> & {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to regenerate token for
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId: string;

  /**
   * token_expires_in is the duration until the new token expires.
   * If not specified, uses the same duration as the previous token.
   *
   * @generated from field: optional google.protobuf.Duration token_expires_in = 2;
   */
  tokenExpiresIn?: Duration;
};

/**
 * Describes the message gitpod.v1.RegenerateSCIMTokenRequest.
 * Use `create(RegenerateSCIMTokenRequestSchema)` to create a new message.
 */
export const RegenerateSCIMTokenRequestSchema: GenMessage<RegenerateSCIMTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 49);

/**
 * @generated from message gitpod.v1.RegenerateSCIMTokenResponse
 */
export type RegenerateSCIMTokenResponse = Message<"gitpod.v1.RegenerateSCIMTokenResponse"> & {
  /**
   * token is the new bearer token for SCIM API authentication.
   * This invalidates the previous token - store it securely.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * token_expires_at is when the new token will expire
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 2;
   */
  tokenExpiresAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.RegenerateSCIMTokenResponse.
 * Use `create(RegenerateSCIMTokenResponseSchema)` to create a new message.
 */
export const RegenerateSCIMTokenResponseSchema: GenMessage<RegenerateSCIMTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 50);

/**
 * @generated from message gitpod.v1.DomainVerification
 */
export type DomainVerification = Message<"gitpod.v1.DomainVerification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: gitpod.v1.DomainVerificationState state = 4;
   */
  state: DomainVerificationState;

  /**
   * @generated from field: google.protobuf.Timestamp verified_at = 5;
   */
  verifiedAt?: Timestamp;

  /**
   * @generated from field: string verification_token = 6;
   */
  verificationToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.DomainVerification.
 * Use `create(DomainVerificationSchema)` to create a new message.
 */
export const DomainVerificationSchema: GenMessage<DomainVerification> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 51);

/**
 * @generated from message gitpod.v1.CreateDomainVerificationRequest
 */
export type CreateDomainVerificationRequest = Message<"gitpod.v1.CreateDomainVerificationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string domain = 2;
   */
  domain: string;
};

/**
 * Describes the message gitpod.v1.CreateDomainVerificationRequest.
 * Use `create(CreateDomainVerificationRequestSchema)` to create a new message.
 */
export const CreateDomainVerificationRequestSchema: GenMessage<CreateDomainVerificationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 52);

/**
 * @generated from message gitpod.v1.CreateDomainVerificationResponse
 */
export type CreateDomainVerificationResponse = Message<"gitpod.v1.CreateDomainVerificationResponse"> & {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;
};

/**
 * Describes the message gitpod.v1.CreateDomainVerificationResponse.
 * Use `create(CreateDomainVerificationResponseSchema)` to create a new message.
 */
export const CreateDomainVerificationResponseSchema: GenMessage<CreateDomainVerificationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 53);

/**
 * @generated from message gitpod.v1.GetDomainVerificationRequest
 */
export type GetDomainVerificationRequest = Message<"gitpod.v1.GetDomainVerificationRequest"> & {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId: string;
};

/**
 * Describes the message gitpod.v1.GetDomainVerificationRequest.
 * Use `create(GetDomainVerificationRequestSchema)` to create a new message.
 */
export const GetDomainVerificationRequestSchema: GenMessage<GetDomainVerificationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 54);

/**
 * @generated from message gitpod.v1.GetDomainVerificationResponse
 */
export type GetDomainVerificationResponse = Message<"gitpod.v1.GetDomainVerificationResponse"> & {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;
};

/**
 * Describes the message gitpod.v1.GetDomainVerificationResponse.
 * Use `create(GetDomainVerificationResponseSchema)` to create a new message.
 */
export const GetDomainVerificationResponseSchema: GenMessage<GetDomainVerificationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 55);

/**
 * @generated from message gitpod.v1.ListDomainVerificationsRequest
 */
export type ListDomainVerificationsRequest = Message<"gitpod.v1.ListDomainVerificationsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListDomainVerificationsRequest.
 * Use `create(ListDomainVerificationsRequestSchema)` to create a new message.
 */
export const ListDomainVerificationsRequestSchema: GenMessage<ListDomainVerificationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 56);

/**
 * @generated from message gitpod.v1.ListDomainVerificationsResponse
 */
export type ListDomainVerificationsResponse = Message<"gitpod.v1.ListDomainVerificationsResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.DomainVerification domain_verifications = 1;
   */
  domainVerifications: DomainVerification[];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListDomainVerificationsResponse.
 * Use `create(ListDomainVerificationsResponseSchema)` to create a new message.
 */
export const ListDomainVerificationsResponseSchema: GenMessage<ListDomainVerificationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 57);

/**
 * @generated from message gitpod.v1.VerifyDomainRequest
 */
export type VerifyDomainRequest = Message<"gitpod.v1.VerifyDomainRequest"> & {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId: string;
};

/**
 * Describes the message gitpod.v1.VerifyDomainRequest.
 * Use `create(VerifyDomainRequestSchema)` to create a new message.
 */
export const VerifyDomainRequestSchema: GenMessage<VerifyDomainRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 58);

/**
 * @generated from message gitpod.v1.VerifyDomainResponse
 */
export type VerifyDomainResponse = Message<"gitpod.v1.VerifyDomainResponse"> & {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;
};

/**
 * Describes the message gitpod.v1.VerifyDomainResponse.
 * Use `create(VerifyDomainResponseSchema)` to create a new message.
 */
export const VerifyDomainResponseSchema: GenMessage<VerifyDomainResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 59);

/**
 * @generated from message gitpod.v1.DeleteDomainVerificationRequest
 */
export type DeleteDomainVerificationRequest = Message<"gitpod.v1.DeleteDomainVerificationRequest"> & {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteDomainVerificationRequest.
 * Use `create(DeleteDomainVerificationRequestSchema)` to create a new message.
 */
export const DeleteDomainVerificationRequestSchema: GenMessage<DeleteDomainVerificationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 60);

/**
 * @generated from message gitpod.v1.DeleteDomainVerificationResponse
 */
export type DeleteDomainVerificationResponse = Message<"gitpod.v1.DeleteDomainVerificationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteDomainVerificationResponse.
 * Use `create(DeleteDomainVerificationResponseSchema)` to create a new message.
 */
export const DeleteDomainVerificationResponseSchema: GenMessage<DeleteDomainVerificationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 61);

/**
 * OrganizationTierFailedPreconditionDetails is a precondition failure details message used when a feature requires a higher Organization tier.
 *
 * @generated from message gitpod.v1.OrganizationTierFailedPreconditionDetails
 */
export type OrganizationTierFailedPreconditionDetails = Message<"gitpod.v1.OrganizationTierFailedPreconditionDetails"> & {
  /**
   * message is the message to display to the user
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * required_tier is the tier that is required to use the feature
   *
   * @generated from field: gitpod.v1.OrganizationTier required_tier = 2;
   */
  requiredTier: OrganizationTier;
};

/**
 * Describes the message gitpod.v1.OrganizationTierFailedPreconditionDetails.
 * Use `create(OrganizationTierFailedPreconditionDetailsSchema)` to create a new message.
 */
export const OrganizationTierFailedPreconditionDetailsSchema: GenMessage<OrganizationTierFailedPreconditionDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 62);

/**
 * @generated from message gitpod.v1.OrganizationPolicies
 */
export type OrganizationPolicies = Message<"gitpod.v1.OrganizationPolicies"> & {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * maximum_environment_timeout controls the maximum timeout allowed for environments in seconds.
   * 0 means no limit (never). Minimum duration is 30 minutes (1800 seconds).
   *
   * @generated from field: google.protobuf.Duration maximum_environment_timeout = 2;
   */
  maximumEnvironmentTimeout?: Duration;

  /**
   * members_require_projects controls whether environments can only be created from projects by non-admin users
   *
   * @generated from field: bool members_require_projects = 3;
   */
  membersRequireProjects: boolean;

  /**
   * members_create_projects controls whether members can create projects
   *
   * @generated from field: bool members_create_projects = 4;
   */
  membersCreateProjects: boolean;

  /**
   * allowed_editor_ids is the list of editor IDs that are allowed to be used in the organization
   *
   * @generated from field: repeated string allowed_editor_ids = 5;
   */
  allowedEditorIds: string[];

  /**
   * default_editor_id is the default editor ID to be used when a user doesn't specify one
   *
   * @generated from field: string default_editor_id = 6;
   */
  defaultEditorId: string;

  /**
   * allow_local_runners controls whether local runners are allowed to be used in the organization
   *
   * @generated from field: bool allow_local_runners = 7;
   */
  allowLocalRunners: boolean;

  /**
   * maximum_running_environments_per_user limits simultaneously running environments per user
   *
   * @generated from field: int64 maximum_running_environments_per_user = 8;
   */
  maximumRunningEnvironmentsPerUser: bigint;

  /**
   * maximum_environments_per_user limits total environments (running or stopped) per user
   *
   * @generated from field: int64 maximum_environments_per_user = 9;
   */
  maximumEnvironmentsPerUser: bigint;

  /**
   * default_environment_image is the default container image when none is defined in repo
   *
   * @generated from field: string default_environment_image = 10;
   */
  defaultEnvironmentImage: string;

  /**
   * port_sharing_disabled controls whether user-initiated port sharing is disabled in the organization.
   * System ports (VS Code Browser, agents) are always exempt from this policy.
   *
   * @generated from field: bool port_sharing_disabled = 11;
   */
  portSharingDisabled: boolean;

  /**
   * delete_archived_environments_after controls how long archived environments are kept before automatic deletion.
   * 0 means no automatic deletion. Maximum duration is 4 weeks (2419200 seconds).
   *
   * @generated from field: google.protobuf.Duration delete_archived_environments_after = 12;
   */
  deleteArchivedEnvironmentsAfter?: Duration;

  /**
   * agent_policy contains agent-specific policy settings
   *
   * @generated from field: gitpod.v1.AgentPolicy agent_policy = 13;
   */
  agentPolicy?: AgentPolicy;

  /**
   * maximum_environment_lifetime controls for how long environments are allowed to be reused.
   * 0 means no maximum lifetime. Maximum duration is 180 days (15552000 seconds).
   *
   * @generated from field: google.protobuf.Duration maximum_environment_lifetime = 14;
   */
  maximumEnvironmentLifetime?: Duration;

  /**
   * require_custom_domain_access controls whether users must access via custom domain
   * when one is configured. When true, access via app.gitpod.io is blocked.
   *
   * @generated from field: bool require_custom_domain_access = 15;
   */
  requireCustomDomainAccess: boolean;

  /**
   * editor_version_restrictions restricts which editor versions can be used.
   * Maps editor ID to version policy, editor_version_restrictions not set means no restrictions.
   * If empty or not set for an editor, we will use the latest version of the editor
   *
   * @generated from field: map<string, gitpod.v1.EditorVersionPolicy> editor_version_restrictions = 16;
   */
  editorVersionRestrictions: { [key: string]: EditorVersionPolicy };

  /**
   * security_agent_policy contains security agent configuration for the organization.
   * When configured, security agents are automatically deployed to all environments.
   *
   * @generated from field: gitpod.v1.SecurityAgentPolicy security_agent_policy = 17;
   */
  securityAgentPolicy?: SecurityAgentPolicy;

  /**
   * restrict_account_creation_to_scim controls whether account creation is restricted to SCIM-provisioned users only.
   * When true and SCIM is configured for the organization, only users provisioned via SCIM can create accounts.
   *
   * @generated from field: bool restrict_account_creation_to_scim = 18;
   */
  restrictAccountCreationToScim: boolean;

  /**
   * veto_exec_policy contains the veto exec policy for environments.
   *
   * @generated from field: gitpod.v1.VetoExecPolicy veto_exec_policy = 20;
   */
  vetoExecPolicy?: VetoExecPolicy;

  /**
   * maximum_environment_lifetime_strict controls whether environments past their
   * lockdown_at timestamp are blocked from starting.
   *
   * @generated from field: bool maximum_environment_lifetime_strict = 21;
   */
  maximumEnvironmentLifetimeStrict: boolean;
};

/**
 * Describes the message gitpod.v1.OrganizationPolicies.
 * Use `create(OrganizationPoliciesSchema)` to create a new message.
 */
export const OrganizationPoliciesSchema: GenMessage<OrganizationPolicies> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 63);

/**
 * VetoExecPolicy defines the policy for blocking or auditing executable execution in environments.
 *
 * @generated from message gitpod.v1.VetoExecPolicy
 */
export type VetoExecPolicy = Message<"gitpod.v1.VetoExecPolicy"> & {
  /**
   * enabled controls whether executable blocking is active
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * executables is the list of executable paths or names to block
   *
   * @generated from field: repeated string executables = 2;
   */
  executables: string[];

  /**
   * action specifies what action kernel-level controls take on policy violations
   *
   * @generated from field: gitpod.v1.KernelControlsAction action = 3;
   */
  action: KernelControlsAction;

  /**
   * Output only. Executable paths that are protected by the safelist and cannot
   * be blocked by the denylist. Populated by the server from the built-in
   * default safelist. Ignored on update requests.
   *
   * @generated from field: repeated string safelist = 4;
   */
  safelist: string[];
};

/**
 * Describes the message gitpod.v1.VetoExecPolicy.
 * Use `create(VetoExecPolicySchema)` to create a new message.
 */
export const VetoExecPolicySchema: GenMessage<VetoExecPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 64);

/**
 * EditorVersionPolicy defines the version policy for a specific editor
 *
 * @generated from message gitpod.v1.EditorVersionPolicy
 */
export type EditorVersionPolicy = Message<"gitpod.v1.EditorVersionPolicy"> & {
  /**
   * allowed_versions lists the versions that are allowed
   * If empty, we will use the latest version of the editor
   *
   * Examples for JetBrains: `["2025.2", "2025.1", "2024.3"]`
   *
   * @generated from field: repeated string allowed_versions = 1;
   */
  allowedVersions: string[];
};

/**
 * Describes the message gitpod.v1.EditorVersionPolicy.
 * Use `create(EditorVersionPolicySchema)` to create a new message.
 */
export const EditorVersionPolicySchema: GenMessage<EditorVersionPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 65);

/**
 * AgentPolicy contains agent-specific policy settings for an organization
 *
 * @generated from message gitpod.v1.AgentPolicy
 */
export type AgentPolicy = Message<"gitpod.v1.AgentPolicy"> & {
  /**
   * mcp_disabled controls whether MCP (Model Context Protocol) is disabled for agents
   *
   * @generated from field: bool mcp_disabled = 1;
   */
  mcpDisabled: boolean;

  /**
   * command_deny_list contains a list of commands that agents are not allowed to execute
   *
   * @generated from field: repeated string command_deny_list = 2;
   */
  commandDenyList: string[];

  /**
   * scm_tools_disabled controls whether SCM (Source Control Management) tools are disabled for agents
   *
   * @generated from field: bool scm_tools_disabled = 3;
   */
  scmToolsDisabled: boolean;

  /**
   * scm_tools_allowed_group_id restricts SCM tools access to members of this group.
   * Empty means no restriction (all users can use SCM tools if not disabled).
   *
   * @generated from field: string scm_tools_allowed_group_id = 4;
   */
  scmToolsAllowedGroupId: string;

  /**
   * conversation_sharing_policy controls whether agent conversations can be shared
   *
   * @generated from field: gitpod.v1.ConversationSharingPolicy conversation_sharing_policy = 5;
   */
  conversationSharingPolicy: ConversationSharingPolicy;

  /**
   * max_subagents_per_environment limits the number of non-terminal sub-agents
   * a parent can have running simultaneously in the same environment.
   * Valid range: 0-10. Zero means use the default (5).
   *
   * @generated from field: int32 max_subagents_per_environment = 6;
   */
  maxSubagentsPerEnvironment: number;
};

/**
 * Describes the message gitpod.v1.AgentPolicy.
 * Use `create(AgentPolicySchema)` to create a new message.
 */
export const AgentPolicySchema: GenMessage<AgentPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 66);

/**
 * SecurityAgentPolicy contains security agent configuration for an organization.
 * When enabled, security agents are automatically deployed to all environments.
 *
 * @generated from message gitpod.v1.SecurityAgentPolicy
 */
export type SecurityAgentPolicy = Message<"gitpod.v1.SecurityAgentPolicy"> & {
  /**
   * crowdstrike contains CrowdStrike Falcon configuration
   *
   * @generated from field: gitpod.v1.CrowdStrikeConfig crowdstrike = 1;
   */
  crowdstrike?: CrowdStrikeConfig;

  /**
   * custom_agents contains custom security agent definitions
   *
   * @generated from field: repeated gitpod.v1.CustomSecurityAgent custom_agents = 2;
   */
  customAgents: CustomSecurityAgent[];
};

/**
 * Describes the message gitpod.v1.SecurityAgentPolicy.
 * Use `create(SecurityAgentPolicySchema)` to create a new message.
 */
export const SecurityAgentPolicySchema: GenMessage<SecurityAgentPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 67);

/**
 * CrowdStrikeConfig configures CrowdStrike Falcon sensor deployment
 *
 * @generated from message gitpod.v1.CrowdStrikeConfig
 */
export type CrowdStrikeConfig = Message<"gitpod.v1.CrowdStrikeConfig"> & {
  /**
   * enabled controls whether CrowdStrike Falcon is deployed to environments
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * image is the CrowdStrike Falcon sensor container image reference
   *
   * @generated from field: string image = 2;
   */
  image: string;

  /**
   * cid_secret_id references an organization secret containing the Customer ID (CID).
   *
   * @generated from field: string cid_secret_id = 3;
   */
  cidSecretId: string;

  /**
   * tags are optional tags to apply to the Falcon sensor (comma-separated)
   *
   * @generated from field: string tags = 4;
   */
  tags: string;

  /**
   * additional_options contains additional FALCONCTL_OPT_* options as key-value pairs.
   * Keys should NOT include the FALCONCTL_OPT_ prefix.
   *
   * @generated from field: map<string, string> additional_options = 5;
   */
  additionalOptions: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.CrowdStrikeConfig.
 * Use `create(CrowdStrikeConfigSchema)` to create a new message.
 */
export const CrowdStrikeConfigSchema: GenMessage<CrowdStrikeConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 68);

/**
 * CustomSecurityAgent defines a custom security agent configured by an organization admin.
 *
 * @generated from message gitpod.v1.CustomSecurityAgent
 */
export type CustomSecurityAgent = Message<"gitpod.v1.CustomSecurityAgent"> & {
  /**
   * id is a unique identifier for this custom agent within the organization.
   * Server-generated at save time if empty.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * enabled controls whether this custom agent is deployed to environments
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * name is the display name for this custom agent
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * description is a human-readable description of what this agent does
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * start_command is the shell script that starts the agent
   *
   * @generated from field: string start_command = 5;
   */
  startCommand: string;

  /**
   * env_mappings maps script placeholders to organization secret names,
   * resolved to secret values at runtime.
   *
   * @generated from field: repeated gitpod.v1.CustomAgentEnvMapping env_mappings = 6;
   */
  envMappings: CustomAgentEnvMapping[];
};

/**
 * Describes the message gitpod.v1.CustomSecurityAgent.
 * Use `create(CustomSecurityAgentSchema)` to create a new message.
 */
export const CustomSecurityAgentSchema: GenMessage<CustomSecurityAgent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 69);

/**
 * CustomAgentEnvMapping maps a script placeholder to an organization secret.
 * The backend resolves the secret name to a UUID at runtime.
 *
 * @generated from message gitpod.v1.CustomAgentEnvMapping
 */
export type CustomAgentEnvMapping = Message<"gitpod.v1.CustomAgentEnvMapping"> & {
  /**
   * name is the environment variable name used as a placeholder in the start command.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * secret_name is the name of the organization secret whose value populates this placeholder.
   *
   * @generated from field: string secret_name = 2;
   */
  secretName: string;
};

/**
 * Describes the message gitpod.v1.CustomAgentEnvMapping.
 * Use `create(CustomAgentEnvMappingSchema)` to create a new message.
 */
export const CustomAgentEnvMappingSchema: GenMessage<CustomAgentEnvMapping> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 70);

/**
 * @generated from message gitpod.v1.GetOrganizationPoliciesRequest
 */
export type GetOrganizationPoliciesRequest = Message<"gitpod.v1.GetOrganizationPoliciesRequest"> & {
  /**
   * organization_id is the ID of the organization to retrieve policies for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetOrganizationPoliciesRequest.
 * Use `create(GetOrganizationPoliciesRequestSchema)` to create a new message.
 */
export const GetOrganizationPoliciesRequestSchema: GenMessage<GetOrganizationPoliciesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 71);

/**
 * @generated from message gitpod.v1.GetOrganizationPoliciesResponse
 */
export type GetOrganizationPoliciesResponse = Message<"gitpod.v1.GetOrganizationPoliciesResponse"> & {
  /**
   * @generated from field: gitpod.v1.OrganizationPolicies policies = 1;
   */
  policies?: OrganizationPolicies;
};

/**
 * Describes the message gitpod.v1.GetOrganizationPoliciesResponse.
 * Use `create(GetOrganizationPoliciesResponseSchema)` to create a new message.
 */
export const GetOrganizationPoliciesResponseSchema: GenMessage<GetOrganizationPoliciesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 72);

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest
 */
export type UpdateOrganizationPoliciesRequest = Message<"gitpod.v1.UpdateOrganizationPoliciesRequest"> & {
  /**
   * organization_id is the ID of the organization to update policies for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * maximum_environment_timeout controls the maximum timeout allowed for environments in seconds.
   * 0 means no limit (never). Minimum duration is 30 minutes (1800 seconds).
   *
   * @generated from field: optional google.protobuf.Duration maximum_environment_timeout = 2;
   */
  maximumEnvironmentTimeout?: Duration;

  /**
   * members_require_projects controls whether environments can only be created from projects by non-admin users
   *
   * @generated from field: optional bool members_require_projects = 3;
   */
  membersRequireProjects?: boolean;

  /**
   * members_create_projects controls whether members can create projects
   *
   * @generated from field: optional bool members_create_projects = 4;
   */
  membersCreateProjects?: boolean;

  /**
   * allowed_editor_ids is the list of editor IDs that are allowed to be used in the organization
   *
   * @generated from field: repeated string allowed_editor_ids = 5;
   */
  allowedEditorIds: string[];

  /**
   * default_editor_id is the default editor ID to be used when a user doesn't specify one
   *
   * @generated from field: optional string default_editor_id = 6;
   */
  defaultEditorId?: string;

  /**
   * allow_local_runners controls whether local runners are allowed to be used in the organization
   *
   * @generated from field: optional bool allow_local_runners = 7;
   */
  allowLocalRunners?: boolean;

  /**
   * maximum_running_environments_per_user limits simultaneously running environments per user
   *
   * @generated from field: optional int64 maximum_running_environments_per_user = 8;
   */
  maximumRunningEnvironmentsPerUser?: bigint;

  /**
   * maximum_environments_per_user limits total environments (running or stopped) per user
   *
   * @generated from field: optional int64 maximum_environments_per_user = 9;
   */
  maximumEnvironmentsPerUser?: bigint;

  /**
   * default_environment_image is the default container image when none is defined in repo
   *
   * @generated from field: optional string default_environment_image = 10;
   */
  defaultEnvironmentImage?: string;

  /**
   * port_sharing_disabled controls whether user-initiated port sharing is disabled in the organization.
   * System ports (VS Code Browser, agents) are always exempt from this policy.
   *
   * @generated from field: optional bool port_sharing_disabled = 11;
   */
  portSharingDisabled?: boolean;

  /**
   * delete_archived_environments_after controls how long archived environments are kept before automatic deletion.
   * 0 means no automatic deletion. Maximum duration is 4 weeks (2419200 seconds).
   *
   * @generated from field: optional google.protobuf.Duration delete_archived_environments_after = 12;
   */
  deleteArchivedEnvironmentsAfter?: Duration;

  /**
   * agent_policy contains agent-specific policy settings
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy agent_policy = 13;
   */
  agentPolicy?: UpdateOrganizationPoliciesRequest_UpdateAgentPolicy;

  /**
   * maximum_environment_lifetime controls for how long environments are allowed to be reused.
   * 0 means no maximum lifetime. Maximum duration is 180 days (15552000 seconds).
   *
   * @generated from field: optional google.protobuf.Duration maximum_environment_lifetime = 14;
   */
  maximumEnvironmentLifetime?: Duration;

  /**
   * require_custom_domain_access controls whether users must access via custom domain
   * when one is configured. When true, access via app.gitpod.io is blocked.
   *
   * @generated from field: optional bool require_custom_domain_access = 15;
   */
  requireCustomDomainAccess?: boolean;

  /**
   * editor_version_restrictions restricts which editor versions can be used.
   * Maps editor ID to version policy with allowed major versions.
   *
   * @generated from field: map<string, gitpod.v1.EditorVersionPolicy> editor_version_restrictions = 16;
   */
  editorVersionRestrictions: { [key: string]: EditorVersionPolicy };

  /**
   * security_agent_policy contains security agent configuration updates
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy security_agent_policy = 17;
   */
  securityAgentPolicy?: UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy;

  /**
   * restrict_account_creation_to_scim controls whether account creation is restricted to SCIM-provisioned users only.
   * When true and SCIM is configured for the organization, only users provisioned via SCIM can create accounts.
   *
   * @generated from field: optional bool restrict_account_creation_to_scim = 18;
   */
  restrictAccountCreationToScim?: boolean;

  /**
   * veto_exec_policy contains the veto exec policy for environments.
   *
   * @generated from field: optional gitpod.v1.VetoExecPolicy veto_exec_policy = 20;
   */
  vetoExecPolicy?: VetoExecPolicy;

  /**
   * maximum_environment_lifetime_strict controls whether environments past their
   * lockdown_at timestamp are blocked from starting.
   *
   * @generated from field: optional bool maximum_environment_lifetime_strict = 21;
   */
  maximumEnvironmentLifetimeStrict?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationPoliciesRequest.
 * Use `create(UpdateOrganizationPoliciesRequestSchema)` to create a new message.
 */
export const UpdateOrganizationPoliciesRequestSchema: GenMessage<UpdateOrganizationPoliciesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 73);

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy
 */
export type UpdateOrganizationPoliciesRequest_UpdateAgentPolicy = Message<"gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy"> & {
  /**
   * mcp_disabled controls whether MCP (Model Context Protocol) is disabled for agents
   *
   * @generated from field: optional bool mcp_disabled = 1;
   */
  mcpDisabled?: boolean;

  /**
   * command_deny_list contains a list of commands that agents are not allowed to execute
   *
   * @generated from field: repeated string command_deny_list = 2;
   */
  commandDenyList: string[];

  /**
   * scm_tools_disabled controls whether SCM (Source Control Management) tools are disabled for agents
   *
   * @generated from field: optional bool scm_tools_disabled = 3;
   */
  scmToolsDisabled?: boolean;

  /**
   * scm_tools_allowed_group_id restricts SCM tools access to members of this group.
   * Empty means no restriction (all users can use SCM tools if not disabled).
   *
   * @generated from field: optional string scm_tools_allowed_group_id = 4;
   */
  scmToolsAllowedGroupId?: string;

  /**
   * conversation_sharing_policy controls whether agent conversations can be shared
   *
   * @generated from field: optional gitpod.v1.ConversationSharingPolicy conversation_sharing_policy = 5;
   */
  conversationSharingPolicy?: ConversationSharingPolicy;

  /**
   * max_subagents_per_environment limits the number of non-terminal sub-agents
   * a parent can have running simultaneously in the same environment.
   * Valid range: 0-10. Zero means use the default (5).
   *
   * @generated from field: optional int32 max_subagents_per_environment = 6;
   */
  maxSubagentsPerEnvironment?: number;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy.
 * Use `create(UpdateOrganizationPoliciesRequest_UpdateAgentPolicySchema)` to create a new message.
 */
export const UpdateOrganizationPoliciesRequest_UpdateAgentPolicySchema: GenMessage<UpdateOrganizationPoliciesRequest_UpdateAgentPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 73, 0);

/**
 * UpdateSecurityAgentPolicy contains security agent configuration updates
 *
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy
 */
export type UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy = Message<"gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy"> & {
  /**
   * crowdstrike contains CrowdStrike Falcon configuration updates
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig crowdstrike = 1;
   */
  crowdstrike?: UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig;

  /**
   * custom_agents contains custom security agent definitions.
   * Callers must read-then-write the full list.
   *
   * @generated from field: repeated gitpod.v1.CustomSecurityAgent custom_agents = 2;
   */
  customAgents: CustomSecurityAgent[];
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy.
 * Use `create(UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicySchema)` to create a new message.
 */
export const UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicySchema: GenMessage<UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 73, 1);

/**
 * UpdateCrowdStrikeConfig contains CrowdStrike Falcon configuration updates
 *
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig
 */
export type UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig = Message<"gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig"> & {
  /**
   * enabled controls whether CrowdStrike Falcon is deployed to environments
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * image is the CrowdStrike Falcon sensor container image reference
   *
   * @generated from field: optional string image = 2;
   */
  image?: string;

  /**
   * cid_secret_id references an organization secret containing the Customer ID (CID)
   *
   * @generated from field: optional string cid_secret_id = 3;
   */
  cidSecretId?: string;

  /**
   * tags are optional tags to apply to the Falcon sensor
   *
   * @generated from field: optional string tags = 4;
   */
  tags?: string;

  /**
   * additional_options contains additional FALCONCTL_OPT_* options as key-value pairs
   *
   * @generated from field: map<string, string> additional_options = 5;
   */
  additionalOptions: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig.
 * Use `create(UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfigSchema)` to create a new message.
 */
export const UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfigSchema: GenMessage<UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 73, 2);

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesResponse
 */
export type UpdateOrganizationPoliciesResponse = Message<"gitpod.v1.UpdateOrganizationPoliciesResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationPoliciesResponse.
 * Use `create(UpdateOrganizationPoliciesResponseSchema)` to create a new message.
 */
export const UpdateOrganizationPoliciesResponseSchema: GenMessage<UpdateOrganizationPoliciesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 74);

/**
 * PolicyEnforcedFailedPreconditionDetails is a precondition failure details message used when a feature is limited by the organization's policy.
 *
 * @generated from message gitpod.v1.PolicyEnforcedFailedPreconditionDetails
 */
export type PolicyEnforcedFailedPreconditionDetails = Message<"gitpod.v1.PolicyEnforcedFailedPreconditionDetails"> & {
  /**
   * message is the message to display to the user
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * policy_name is the name of the policy that is enforced
   *
   * @generated from field: string policy_name = 2;
   */
  policyName: string;

  /**
   * details contains policy-specific structured data for richer error messages.
   *
   * @generated from oneof gitpod.v1.PolicyEnforcedFailedPreconditionDetails.details
   */
  details: {
    /**
     * @generated from field: gitpod.v1.EnvironmentMaxLifetimeExceededDetails max_lifetime_exceeded = 3;
     */
    value: EnvironmentMaxLifetimeExceededDetails;
    case: "maxLifetimeExceeded";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.PolicyEnforcedFailedPreconditionDetails.
 * Use `create(PolicyEnforcedFailedPreconditionDetailsSchema)` to create a new message.
 */
export const PolicyEnforcedFailedPreconditionDetailsSchema: GenMessage<PolicyEnforcedFailedPreconditionDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 75);

/**
 * EnvironmentMaxLifetimeExceededDetails contains details about why an environment
 * was rejected due to the maximum lifetime policy.
 *
 * @generated from message gitpod.v1.EnvironmentMaxLifetimeExceededDetails
 */
export type EnvironmentMaxLifetimeExceededDetails = Message<"gitpod.v1.EnvironmentMaxLifetimeExceededDetails"> & {
  /**
   * expired_at is the timestamp when the environment's lifetime expired (its lockdown_at value).
   *
   * @generated from field: google.protobuf.Timestamp expired_at = 1;
   */
  expiredAt?: Timestamp;

  /**
   * policy_value is the configured maximum environment lifetime duration.
   *
   * @generated from field: google.protobuf.Duration policy_value = 2;
   */
  policyValue?: Duration;
};

/**
 * Describes the message gitpod.v1.EnvironmentMaxLifetimeExceededDetails.
 * Use `create(EnvironmentMaxLifetimeExceededDetailsSchema)` to create a new message.
 */
export const EnvironmentMaxLifetimeExceededDetailsSchema: GenMessage<EnvironmentMaxLifetimeExceededDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 76);

/**
 * @generated from message gitpod.v1.AnnouncementBanner
 */
export type AnnouncementBanner = Message<"gitpod.v1.AnnouncementBanner"> & {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * message is the banner message displayed to users. Supports basic Markdown.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * enabled controls whether the banner is displayed
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;
};

/**
 * Describes the message gitpod.v1.AnnouncementBanner.
 * Use `create(AnnouncementBannerSchema)` to create a new message.
 */
export const AnnouncementBannerSchema: GenMessage<AnnouncementBanner> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 77);

/**
 * @generated from message gitpod.v1.GetAnnouncementBannerRequest
 */
export type GetAnnouncementBannerRequest = Message<"gitpod.v1.GetAnnouncementBannerRequest"> & {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetAnnouncementBannerRequest.
 * Use `create(GetAnnouncementBannerRequestSchema)` to create a new message.
 */
export const GetAnnouncementBannerRequestSchema: GenMessage<GetAnnouncementBannerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 78);

/**
 * @generated from message gitpod.v1.GetAnnouncementBannerResponse
 */
export type GetAnnouncementBannerResponse = Message<"gitpod.v1.GetAnnouncementBannerResponse"> & {
  /**
   * banner is the announcement banner configuration
   *
   * @generated from field: gitpod.v1.AnnouncementBanner banner = 1;
   */
  banner?: AnnouncementBanner;
};

/**
 * Describes the message gitpod.v1.GetAnnouncementBannerResponse.
 * Use `create(GetAnnouncementBannerResponseSchema)` to create a new message.
 */
export const GetAnnouncementBannerResponseSchema: GenMessage<GetAnnouncementBannerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 79);

/**
 * @generated from message gitpod.v1.UpdateAnnouncementBannerRequest
 */
export type UpdateAnnouncementBannerRequest = Message<"gitpod.v1.UpdateAnnouncementBannerRequest"> & {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * message is the banner message. Supports basic Markdown. Maximum 1000 characters.
   *
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * enabled controls whether the banner is displayed
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdateAnnouncementBannerRequest.
 * Use `create(UpdateAnnouncementBannerRequestSchema)` to create a new message.
 */
export const UpdateAnnouncementBannerRequestSchema: GenMessage<UpdateAnnouncementBannerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 80);

/**
 * @generated from message gitpod.v1.UpdateAnnouncementBannerResponse
 */
export type UpdateAnnouncementBannerResponse = Message<"gitpod.v1.UpdateAnnouncementBannerResponse"> & {
  /**
   * banner is the updated announcement banner configuration
   *
   * @generated from field: gitpod.v1.AnnouncementBanner banner = 1;
   */
  banner?: AnnouncementBanner;
};

/**
 * Describes the message gitpod.v1.UpdateAnnouncementBannerResponse.
 * Use `create(UpdateAnnouncementBannerResponseSchema)` to create a new message.
 */
export const UpdateAnnouncementBannerResponseSchema: GenMessage<UpdateAnnouncementBannerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 81);

/**
 * @generated from message gitpod.v1.SetTierRequest
 */
export type SetTierRequest = Message<"gitpod.v1.SetTierRequest"> & {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * tier is the new tier to set for the organization
   *
   * @generated from field: gitpod.v1.OrganizationTier tier = 2;
   */
  tier: OrganizationTier;
};

/**
 * Describes the message gitpod.v1.SetTierRequest.
 * Use `create(SetTierRequestSchema)` to create a new message.
 */
export const SetTierRequestSchema: GenMessage<SetTierRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 82);

/**
 * @generated from message gitpod.v1.SetTierResponse
 */
export type SetTierResponse = Message<"gitpod.v1.SetTierResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetTierResponse.
 * Use `create(SetTierResponseSchema)` to create a new message.
 */
export const SetTierResponseSchema: GenMessage<SetTierResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 83);

/**
 * @generated from message gitpod.v1.SetStripeCustomerIDRequest
 */
export type SetStripeCustomerIDRequest = Message<"gitpod.v1.SetStripeCustomerIDRequest"> & {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * stripe_customer_id is the Stripe customer ID to associate with the organization
   *
   * @generated from field: string stripe_customer_id = 2;
   */
  stripeCustomerId: string;
};

/**
 * Describes the message gitpod.v1.SetStripeCustomerIDRequest.
 * Use `create(SetStripeCustomerIDRequestSchema)` to create a new message.
 */
export const SetStripeCustomerIDRequestSchema: GenMessage<SetStripeCustomerIDRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 84);

/**
 * @generated from message gitpod.v1.SetStripeCustomerIDResponse
 */
export type SetStripeCustomerIDResponse = Message<"gitpod.v1.SetStripeCustomerIDResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetStripeCustomerIDResponse.
 * Use `create(SetStripeCustomerIDResponseSchema)` to create a new message.
 */
export const SetStripeCustomerIDResponseSchema: GenMessage<SetStripeCustomerIDResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 85);

/**
 * CustomDomain represents a custom domain configuration for an organization
 *
 * @generated from message gitpod.v1.CustomDomain
 */
export type CustomDomain = Message<"gitpod.v1.CustomDomain"> & {
  /**
   * id is the unique identifier of the custom domain
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * organization_id is the ID of the organization this custom domain belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 3;
   */
  domainName: string;

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: gitpod.v1.CustomDomainProvider provider = 4;
   */
  provider: CustomDomainProvider;

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: string aws_account_id = 5 [deprecated = true];
   * @deprecated
   */
  awsAccountId: string;

  /**
   * created_at is when the custom domain was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the custom domain was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: string cloud_account_id = 8;
   */
  cloudAccountId: string;
};

/**
 * Describes the message gitpod.v1.CustomDomain.
 * Use `create(CustomDomainSchema)` to create a new message.
 */
export const CustomDomainSchema: GenMessage<CustomDomain> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 86);

/**
 * CreateCustomDomainRequest is the request message for creating a custom domain
 *
 * @generated from message gitpod.v1.CreateCustomDomainRequest
 */
export type CreateCustomDomainRequest = Message<"gitpod.v1.CreateCustomDomainRequest"> & {
  /**
   * organization_id is the ID of the organization to create the custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 2;
   */
  domainName: string;

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: gitpod.v1.CustomDomainProvider provider = 3;
   */
  provider: CustomDomainProvider;

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: optional string aws_account_id = 4 [deprecated = true];
   * @deprecated
   */
  awsAccountId?: string;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: optional string cloud_account_id = 5;
   */
  cloudAccountId?: string;
};

/**
 * Describes the message gitpod.v1.CreateCustomDomainRequest.
 * Use `create(CreateCustomDomainRequestSchema)` to create a new message.
 */
export const CreateCustomDomainRequestSchema: GenMessage<CreateCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 87);

/**
 * CreateCustomDomainResponse is the response message for creating a custom domain
 *
 * @generated from message gitpod.v1.CreateCustomDomainResponse
 */
export type CreateCustomDomainResponse = Message<"gitpod.v1.CreateCustomDomainResponse"> & {
  /**
   * custom_domain is the created custom domain
   *
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;
};

/**
 * Describes the message gitpod.v1.CreateCustomDomainResponse.
 * Use `create(CreateCustomDomainResponseSchema)` to create a new message.
 */
export const CreateCustomDomainResponseSchema: GenMessage<CreateCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 88);

/**
 * GetCustomDomainRequest is the request message for getting a custom domain
 *
 * @generated from message gitpod.v1.GetCustomDomainRequest
 */
export type GetCustomDomainRequest = Message<"gitpod.v1.GetCustomDomainRequest"> & {
  /**
   * organization_id is the ID of the organization to retrieve custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetCustomDomainRequest.
 * Use `create(GetCustomDomainRequestSchema)` to create a new message.
 */
export const GetCustomDomainRequestSchema: GenMessage<GetCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 89);

/**
 * @generated from message gitpod.v1.GetCustomDomainResponse
 */
export type GetCustomDomainResponse = Message<"gitpod.v1.GetCustomDomainResponse"> & {
  /**
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;
};

/**
 * Describes the message gitpod.v1.GetCustomDomainResponse.
 * Use `create(GetCustomDomainResponseSchema)` to create a new message.
 */
export const GetCustomDomainResponseSchema: GenMessage<GetCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 90);

/**
 * UpdateCustomDomainRequest is the request message for updating a custom domain
 *
 * @generated from message gitpod.v1.UpdateCustomDomainRequest
 */
export type UpdateCustomDomainRequest = Message<"gitpod.v1.UpdateCustomDomainRequest"> & {
  /**
   * organization_id is the ID of the organization to update custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 2;
   */
  domainName: string;

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: optional string aws_account_id = 3 [deprecated = true];
   * @deprecated
   */
  awsAccountId?: string;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: optional string cloud_account_id = 4;
   */
  cloudAccountId?: string;

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: optional gitpod.v1.CustomDomainProvider provider = 5;
   */
  provider?: CustomDomainProvider;
};

/**
 * Describes the message gitpod.v1.UpdateCustomDomainRequest.
 * Use `create(UpdateCustomDomainRequestSchema)` to create a new message.
 */
export const UpdateCustomDomainRequestSchema: GenMessage<UpdateCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 91);

/**
 * UpdateCustomDomainResponse is the response message for updating a custom domain
 *
 * @generated from message gitpod.v1.UpdateCustomDomainResponse
 */
export type UpdateCustomDomainResponse = Message<"gitpod.v1.UpdateCustomDomainResponse"> & {
  /**
   * custom_domain is the updated custom domain
   *
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;
};

/**
 * Describes the message gitpod.v1.UpdateCustomDomainResponse.
 * Use `create(UpdateCustomDomainResponseSchema)` to create a new message.
 */
export const UpdateCustomDomainResponseSchema: GenMessage<UpdateCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 92);

/**
 * DeleteCustomDomainRequest is the request message for deleting a custom domain
 *
 * @generated from message gitpod.v1.DeleteCustomDomainRequest
 */
export type DeleteCustomDomainRequest = Message<"gitpod.v1.DeleteCustomDomainRequest"> & {
  /**
   * organization_id is the ID of the organization to delete custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteCustomDomainRequest.
 * Use `create(DeleteCustomDomainRequestSchema)` to create a new message.
 */
export const DeleteCustomDomainRequestSchema: GenMessage<DeleteCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 93);

/**
 * DeleteCustomDomainResponse is the response message for deleting a custom domain
 *
 * @generated from message gitpod.v1.DeleteCustomDomainResponse
 */
export type DeleteCustomDomainResponse = Message<"gitpod.v1.DeleteCustomDomainResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteCustomDomainResponse.
 * Use `create(DeleteCustomDomainResponseSchema)` to create a new message.
 */
export const DeleteCustomDomainResponseSchema: GenMessage<DeleteCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 94);

/**
 * GetOIDCConfigRequest is the request message for retrieving OIDC token configuration.
 *
 * @generated from message gitpod.v1.GetOIDCConfigRequest
 */
export type GetOIDCConfigRequest = Message<"gitpod.v1.GetOIDCConfigRequest"> & {
  /**
   * organization_id is the ID of the organization.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetOIDCConfigRequest.
 * Use `create(GetOIDCConfigRequestSchema)` to create a new message.
 */
export const GetOIDCConfigRequestSchema: GenMessage<GetOIDCConfigRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 95);

/**
 * GetOIDCConfigResponse is the response message for retrieving OIDC token configuration.
 *
 * @generated from message gitpod.v1.GetOIDCConfigResponse
 */
export type GetOIDCConfigResponse = Message<"gitpod.v1.GetOIDCConfigResponse"> & {
  /**
   * oidc_config is the current OIDC token configuration.
   *
   * @generated from field: gitpod.v1.OIDCConfig oidc_config = 1;
   */
  oidcConfig?: OIDCConfig;
};

/**
 * Describes the message gitpod.v1.GetOIDCConfigResponse.
 * Use `create(GetOIDCConfigResponseSchema)` to create a new message.
 */
export const GetOIDCConfigResponseSchema: GenMessage<GetOIDCConfigResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 96);

/**
 * UpdateOIDCConfigRequest is the request message for updating OIDC token configuration.
 *
 * @generated from message gitpod.v1.UpdateOIDCConfigRequest
 */
export type UpdateOIDCConfigRequest = Message<"gitpod.v1.UpdateOIDCConfigRequest"> & {
  /**
   * organization_id is the ID of the organization.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * oidc_config is the desired OIDC token configuration.
   *
   * @generated from field: gitpod.v1.OIDCConfig oidc_config = 2;
   */
  oidcConfig?: OIDCConfig;
};

/**
 * Describes the message gitpod.v1.UpdateOIDCConfigRequest.
 * Use `create(UpdateOIDCConfigRequestSchema)` to create a new message.
 */
export const UpdateOIDCConfigRequestSchema: GenMessage<UpdateOIDCConfigRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 97);

/**
 * UpdateOIDCConfigResponse is the response message for updating OIDC token configuration.
 *
 * @generated from message gitpod.v1.UpdateOIDCConfigResponse
 */
export type UpdateOIDCConfigResponse = Message<"gitpod.v1.UpdateOIDCConfigResponse"> & {
  /**
   * oidc_config is the updated OIDC token configuration.
   *
   * @generated from field: gitpod.v1.OIDCConfig oidc_config = 1;
   */
  oidcConfig?: OIDCConfig;
};

/**
 * Describes the message gitpod.v1.UpdateOIDCConfigResponse.
 * Use `create(UpdateOIDCConfigResponseSchema)` to create a new message.
 */
export const UpdateOIDCConfigResponseSchema: GenMessage<UpdateOIDCConfigResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 98);

/**
 * OIDCConfig represents the OIDC token configuration for an organization.
 * The version oneof determines which token version is active.
 *
 * @generated from message gitpod.v1.OIDCConfig
 */
export type OIDCConfig = Message<"gitpod.v1.OIDCConfig"> & {
  /**
   * @generated from oneof gitpod.v1.OIDCConfig.version
   */
  version: {
    /**
     * v2 selects V2 OIDC tokens (the default for new organizations).
     *
     * @generated from field: gitpod.v1.OIDCConfigV2 v2 = 1;
     */
    value: OIDCConfigV2;
    case: "v2";
  } | {
    /**
     * v3 selects V3 OIDC tokens with richer claims and optional sub claim customization.
     *
     * @generated from field: gitpod.v1.OIDCConfigV3 v3 = 2;
     */
    value: OIDCConfigV3;
    case: "v3";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.OIDCConfig.
 * Use `create(OIDCConfigSchema)` to create a new message.
 */
export const OIDCConfigSchema: GenMessage<OIDCConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 99);

/**
 * OIDCConfigV2 configures V2 OIDC tokens. No additional parameters.
 *
 * @generated from message gitpod.v1.OIDCConfigV2
 */
export type OIDCConfigV2 = Message<"gitpod.v1.OIDCConfigV2"> & {
};

/**
 * Describes the message gitpod.v1.OIDCConfigV2.
 * Use `create(OIDCConfigV2Schema)` to create a new message.
 */
export const OIDCConfigV2Schema: GenMessage<OIDCConfigV2> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 100);

/**
 * OIDCConfigV3 configures V3 OIDC tokens with optional sub claim customization.
 *
 * @generated from message gitpod.v1.OIDCConfigV3
 */
export type OIDCConfigV3 = Message<"gitpod.v1.OIDCConfigV3"> & {
  /**
   * extra_sub_fields are additional property keys to include in the sub claim.
   * Valid keys include: account_id, user_id, organization_id, project_id, runner_id,
   * environment_id, creator_id, creator_principal, creator_email, creator_name,
   * creator_idp, email, name, idp, runner_name, service_account_id, and
   * dot-notation keys like creator_idp_claims.groups or idp_claims.department.
   *
   * @generated from field: repeated string extra_sub_fields = 1;
   */
  extraSubFields: string[];
};

/**
 * Describes the message gitpod.v1.OIDCConfigV3.
 * Use `create(OIDCConfigV3Schema)` to create a new message.
 */
export const OIDCConfigV3Schema: GenMessage<OIDCConfigV3> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_organization, 101);

/**
 * @generated from enum gitpod.v1.OrganizationTier
 */
export enum OrganizationTier {
  /**
   * @generated from enum value: ORGANIZATION_TIER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORGANIZATION_TIER_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: ORGANIZATION_TIER_ENTERPRISE = 2;
   */
  ENTERPRISE = 2,

  /**
   * @generated from enum value: ORGANIZATION_TIER_CORE = 3;
   */
  CORE = 3,

  /**
   * @generated from enum value: ORGANIZATION_TIER_FREE_ONA = 4;
   */
  FREE_ONA = 4,
}

/**
 * Describes the enum gitpod.v1.OrganizationTier.
 */
export const OrganizationTierSchema: GenEnum<OrganizationTier> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 0);

/**
 * @generated from enum gitpod.v1.OrganizationRole
 */
export enum OrganizationRole {
  /**
   * @generated from enum value: ORGANIZATION_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_MEMBER = 2;
   */
  MEMBER = 2,
}

/**
 * Describes the enum gitpod.v1.OrganizationRole.
 */
export const OrganizationRoleSchema: GenEnum<OrganizationRole> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 1);

/**
 * @generated from enum gitpod.v1.SSOConfigurationState
 */
export enum SSOConfigurationState {
  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_UNSPECIFIED = 0;
   */
  SSO_CONFIGURATION_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_INACTIVE = 1;
   */
  SSO_CONFIGURATION_STATE_INACTIVE = 1,

  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_ACTIVE = 2;
   */
  SSO_CONFIGURATION_STATE_ACTIVE = 2,
}

/**
 * Describes the enum gitpod.v1.SSOConfigurationState.
 */
export const SSOConfigurationStateSchema: GenEnum<SSOConfigurationState> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 2);

/**
 * @generated from enum gitpod.v1.DomainVerificationState
 */
export enum DomainVerificationState {
  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_VERIFIED = 2;
   */
  VERIFIED = 2,
}

/**
 * Describes the enum gitpod.v1.DomainVerificationState.
 */
export const DomainVerificationStateSchema: GenEnum<DomainVerificationState> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 3);

/**
 * ConversationSharingPolicy controls how agent conversations can be shared.
 *
 * @generated from enum gitpod.v1.ConversationSharingPolicy
 */
export enum ConversationSharingPolicy {
  /**
   * @generated from enum value: CONVERSATION_SHARING_POLICY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONVERSATION_SHARING_POLICY_DISABLED = 1;
   */
  DISABLED = 1,

  /**
   * @generated from enum value: CONVERSATION_SHARING_POLICY_ORGANIZATION = 2;
   */
  ORGANIZATION = 2,
}

/**
 * Describes the enum gitpod.v1.ConversationSharingPolicy.
 */
export const ConversationSharingPolicySchema: GenEnum<ConversationSharingPolicy> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 4);

/**
 * CustomDomainProvider represents the cloud provider for custom domain configuration
 *
 * @generated from enum gitpod.v1.CustomDomainProvider
 */
export enum CustomDomainProvider {
  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_AWS = 1;
   */
  AWS = 1,

  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_GCP = 2;
   */
  GCP = 2,
}

/**
 * Describes the enum gitpod.v1.CustomDomainProvider.
 */
export const CustomDomainProviderSchema: GenEnum<CustomDomainProvider> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_organization, 5);

/**
 * @generated from service gitpod.v1.OrganizationService
 */
export const OrganizationService: GenService<{
  /**
   * Creates a new organization with the specified name and settings.
   *
   * Use this method to:
   * - Create a new organization for team collaboration
   * - Set up automatic domain-based invites for team members
   * - Join the organization immediately upon creation
   *
   * ### Examples
   *
   * - Create a basic organization:
   *
   *   Creates an organization with just a name.
   *
   *   ```yaml
   *   name: "Acme Corp Engineering"
   *   joinOrganization: true
   *   ```
   *
   * - Create with domain-based invites:
   *
   *   Creates an organization that automatically invites users with matching email domains.
   *
   *   ```yaml
   *   name: "Acme Corp"
   *   joinOrganization: true
   *   inviteAccountsWithMatchingDomain: true
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateOrganization
   */
  createOrganization: {
    methodKind: "unary";
    input: typeof CreateOrganizationRequestSchema;
    output: typeof CreateOrganizationResponseSchema;
  },
  /**
   * Allows users to join an organization through direct ID, invite link, or domain-based auto-join.
   *
   * Use this method to:
   * - Join an organization via direct ID or invite
   * - Join automatically based on email domain
   * - Accept organization invitations
   *
   * ### Examples
   *
   * - Join via organization ID:
   *
   *   Joins an organization directly when you have the ID.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * - Join via invite:
   *
   *   Accepts an organization invitation link.
   *
   *   ```yaml
   *   inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.JoinOrganization
   */
  joinOrganization: {
    methodKind: "unary";
    input: typeof JoinOrganizationRequestSchema;
    output: typeof JoinOrganizationResponseSchema;
  },
  /**
   * Gets details about a specific organization.
   *
   * Use this method to:
   * - Retrieve organization settings and configuration
   * - Check organization membership status
   * - View domain verification settings
   *
   * ### Examples
   *
   * - Get organization details:
   *
   *   Retrieves information about a specific organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof GetOrganizationRequestSchema;
    output: typeof GetOrganizationResponseSchema;
  },
  /**
   * Updates an organization's settings including name, invite domains, and member policies.
   *
   * Use this method to:
   * - Modify organization display name
   * - Configure email domain restrictions
   * - Update organization-wide settings
   * - Manage member access policies
   *
   * ### Examples
   *
   * - Update basic settings:
   *
   *   Changes organization name and invite domains.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   name: "New Company Name"
   *   inviteDomains:
   *     domains:
   *       - "company.com"
   *       - "subsidiary.com"
   *   ```
   *
   * - Remove domain restrictions:
   *
   *   Clears all domain-based invite restrictions.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   inviteDomains:
   *     domains: []
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateOrganization
   */
  updateOrganization: {
    methodKind: "unary";
    input: typeof UpdateOrganizationRequestSchema;
    output: typeof UpdateOrganizationResponseSchema;
  },
  /**
   * Permanently deletes an organization.
   *
   * Use this method to:
   * - Remove unused organizations
   * - Clean up test organizations
   * - Complete organization migration
   *
   * ### Examples
   *
   * - Delete organization:
   *
   *   Permanently removes an organization and all its data.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.DeleteOrganization
   */
  deleteOrganization: {
    methodKind: "unary";
    input: typeof DeleteOrganizationRequestSchema;
    output: typeof DeleteOrganizationResponseSchema;
  },
  /**
   * Lists and filters organization members with optional pagination.
   *
   * Use this method to:
   * - View all organization members
   * - Monitor member activity
   * - Manage team membership
   *
   * ### Examples
   *
   * - List active members:
   *
   *   Retrieves active members with pagination.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List with pagination:
   *
   *   Retrieves next page of members.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 50
   *     token: "next-page-token-from-previous-response"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * Manages organization membership and roles by setting a user's role within the organization.
   *
   * Use this method to:
   * - Promote members to admin role
   * - Change member permissions
   * - Demote admins to regular members
   *
   * ### Examples
   *
   * - Promote to admin:
   *
   *   Makes a user an organization administrator.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   role: ORGANIZATION_ROLE_ADMIN
   *   ```
   *
   * - Change to member:
   *
   *   Changes a user's role to regular member.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   role: ORGANIZATION_ROLE_MEMBER
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.SetRole
   */
  setRole: {
    methodKind: "unary";
    input: typeof SetRoleRequestSchema;
    output: typeof SetRoleResponseSchema;
  },
  /**
   * Creates an invite link for joining an organization.
   * Any existing OrganizationInvites are invalidated and can no longer be used.
   *
   * Use this method to:
   * - Generate shareable invite links
   * - Manage team growth
   * - Control organization access
   *
   * ### Examples
   *
   * - Create organization invite:
   *
   *   Generates a new invite link for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateOrganizationInvite
   */
  createOrganizationInvite: {
    methodKind: "unary";
    input: typeof CreateOrganizationInviteRequestSchema;
    output: typeof CreateOrganizationInviteResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationInvite
   */
  getOrganizationInvite: {
    methodKind: "unary";
    input: typeof GetOrganizationInviteRequestSchema;
    output: typeof GetOrganizationInviteResponseSchema;
  },
  /**
   * Retrieves organization details and membership info based on an invite link.
   *
   * Use this method to:
   * - Preview organization details before joining
   * - Validate invite link authenticity
   * - Check organization size and activity
   * - View team information before accepting
   *
   * ### Examples
   *
   * - Get invite summary:
   *
   *   Retrieves organization information from an invite.
   *
   *   ```yaml
   *   inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationInviteSummary
   */
  getOrganizationInviteSummary: {
    methodKind: "unary";
    input: typeof GetOrganizationInviteSummaryRequestSchema;
    output: typeof GetOrganizationInviteSummaryResponseSchema;
  },
  /**
   * Removes a user from an organization while preserving organization data.
   *
   * Use this method to:
   * - Remove yourself from an organization
   * - Clean up inactive memberships
   * - Transfer project ownership before leaving
   * - Manage team transitions
   *
   * ### Examples
   *
   * - Leave organization:
   *
   *   Removes user from organization membership.
   *
   *   ```yaml
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   ```
   *
   * Note: Ensure all projects and resources are transferred before leaving.
   *
   * @generated from rpc gitpod.v1.OrganizationService.LeaveOrganization
   */
  leaveOrganization: {
    methodKind: "unary";
    input: typeof LeaveOrganizationRequestSchema;
    output: typeof LeaveOrganizationResponseSchema;
  },
  /**
   * Creates or updates SSO configuration for organizational authentication.
   *
   * Use this method to:
   * - Configure OIDC-based SSO providers
   * - Set up built-in providers (Google, GitHub, etc.)
   * - Define custom identity providers
   * - Manage authentication policies
   *
   * ### Examples
   *
   * - Configure built-in Google SSO:
   *
   *   Sets up SSO using Google Workspace.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   clientId: "012345678-abcdefghijklmnopqrstuvwxyz.apps.googleusercontent.com"
   *   clientSecret: "GOCSPX-abcdefghijklmnopqrstuvwxyz123456"
   *   issuerUrl: "https://accounts.google.com"
   *   emailDomain: "acme-corp.com"
   *   ```
   *
   * - Configure custom OIDC provider:
   *
   *   Sets up SSO with a custom identity provider.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   clientId: "acme-corp-gitpod"
   *   clientSecret: "secret-token-value"
   *   issuerUrl: "https://sso.acme-corp.com"
   *   emailDomain: "acme-corp.com"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateSSOConfiguration
   */
  createSSOConfiguration: {
    methodKind: "unary";
    input: typeof CreateSSOConfigurationRequestSchema;
    output: typeof CreateSSOConfigurationResponseSchema;
  },
  /**
   * Retrieves a specific SSO configuration.
   *
   * Use this method to:
   * - View SSO provider details
   * - Check configuration status
   * - Verify SSO settings
   *
   * ### Examples
   *
   * - Get SSO configuration:
   *
   *   Retrieves details of a specific SSO configuration.
   *
   *   ```yaml
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetSSOConfiguration
   */
  getSSOConfiguration: {
    methodKind: "unary";
    input: typeof GetSSOConfigurationRequestSchema;
    output: typeof GetSSOConfigurationResponseSchema;
  },
  /**
   * Lists and filters SSO configurations for an organization.
   *
   * Use this method to:
   * - View all SSO providers
   * - Monitor authentication status
   * - Audit security settings
   * - Manage provider configurations
   *
   * ### Examples
   *
   * - List active configurations:
   *
   *   Shows all active SSO providers.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List by provider type:
   *
   *   Shows custom SSO configurations.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *     token: "next-page-token-from-previous-response"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.ListSSOConfigurations
   */
  listSSOConfigurations: {
    methodKind: "unary";
    input: typeof ListSSOConfigurationsRequestSchema;
    output: typeof ListSSOConfigurationsResponseSchema;
  },
  /**
   * Removes an SSO configuration from an organization.
   *
   * Use this method to:
   * - Disable SSO authentication
   * - Remove outdated providers
   * - Clean up unused configurations
   *
   * ### Examples
   *
   * - Delete SSO configuration:
   *
   *   Removes a specific SSO configuration.
   *
   *   ```yaml
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.DeleteSSOConfiguration
   */
  deleteSSOConfiguration: {
    methodKind: "unary";
    input: typeof DeleteSSOConfigurationRequestSchema;
    output: typeof DeleteSSOConfigurationResponseSchema;
  },
  /**
   * Updates SSO provider settings and authentication rules.
   *
   * Use this method to:
   * - Rotate client credentials
   * - Update provider endpoints
   * - Modify claim mappings
   * - Change authentication policies
   * - Toggle SSO enforcement
   *
   * ### Examples
   *
   * - Update credentials:
   *
   *   Rotates client ID and secret.
   *
   *   ```yaml
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   clientId: "new-client-id"
   *   clientSecret: "new-client-secret"
   *   ```
   *
   * - Update provider status:
   *
   *   Activates or deactivates SSO provider.
   *
   *   ```yaml
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   state: SSO_CONFIGURATION_STATE_ACTIVE
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateSSOConfiguration
   */
  updateSSOConfiguration: {
    methodKind: "unary";
    input: typeof UpdateSSOConfigurationRequestSchema;
    output: typeof UpdateSSOConfigurationResponseSchema;
  },
  /**
   * Creates a new SCIM configuration for automated user provisioning.
   *
   * Use this method to:
   * - Set up SCIM 2.0 provisioning from an identity provider
   * - Generate a bearer token for SCIM API authentication
   * - Link SCIM provisioning to an existing SSO configuration
   *
   * ### Examples
   *
   * - Create basic SCIM configuration:
   *
   *   Creates a SCIM configuration linked to an SSO provider with default 1 year token expiration.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * - Create SCIM configuration with custom token expiration:
   *
   *   Creates a SCIM configuration with a 90-day token expiration.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   tokenExpiresIn: "7776000s"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateSCIMConfiguration
   */
  createSCIMConfiguration: {
    methodKind: "unary";
    input: typeof CreateSCIMConfigurationRequestSchema;
    output: typeof CreateSCIMConfigurationResponseSchema;
  },
  /**
   * Retrieves a specific SCIM configuration.
   *
   * Use this method to:
   * - View SCIM configuration details
   * - Check if SCIM is enabled
   * - Verify SSO linkage
   *
   * ### Examples
   *
   * - Get SCIM configuration:
   *
   *   Retrieves details of a specific SCIM configuration.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetSCIMConfiguration
   */
  getSCIMConfiguration: {
    methodKind: "unary";
    input: typeof GetSCIMConfigurationRequestSchema;
    output: typeof GetSCIMConfigurationResponseSchema;
  },
  /**
   * Lists SCIM configurations for an organization.
   *
   * Use this method to:
   * - View all SCIM configurations
   * - Monitor provisioning status
   * - Audit SCIM settings
   *
   * ### Examples
   *
   * - List SCIM configurations:
   *
   *   Shows all SCIM configurations for an organization.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.ListSCIMConfigurations
   */
  listSCIMConfigurations: {
    methodKind: "unary";
    input: typeof ListSCIMConfigurationsRequestSchema;
    output: typeof ListSCIMConfigurationsResponseSchema;
  },
  /**
   * Updates a SCIM configuration.
   *
   * Use this method to:
   * - Enable or disable SCIM provisioning
   * - Link or unlink SSO configuration
   * - Update configuration name
   *
   * ### Examples
   *
   * - Disable SCIM:
   *
   *   Disables SCIM provisioning.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   enabled: false
   *   ```
   *
   * - Link to SSO:
   *
   *   Links SCIM configuration to an SSO provider.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ssoConfigurationId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateSCIMConfiguration
   */
  updateSCIMConfiguration: {
    methodKind: "unary";
    input: typeof UpdateSCIMConfigurationRequestSchema;
    output: typeof UpdateSCIMConfigurationResponseSchema;
  },
  /**
   * Removes a SCIM configuration from an organization.
   *
   * Use this method to:
   * - Disable SCIM provisioning completely
   * - Remove unused configurations
   * - Clean up after migration
   *
   * ### Examples
   *
   * - Delete SCIM configuration:
   *
   *   Removes a specific SCIM configuration.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.DeleteSCIMConfiguration
   */
  deleteSCIMConfiguration: {
    methodKind: "unary";
    input: typeof DeleteSCIMConfigurationRequestSchema;
    output: typeof DeleteSCIMConfigurationResponseSchema;
  },
  /**
   * Regenerates the bearer token for a SCIM configuration.
   *
   * Use this method to:
   * - Rotate SCIM credentials
   * - Recover from token compromise
   * - Update IdP configuration
   *
   * ### Examples
   *
   * - Regenerate token:
   *
   *   Creates a new bearer token with the same expiration duration as the previous token.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * - Regenerate token with new expiration:
   *
   *   Creates a new bearer token with a custom 180-day expiration.
   *
   *   ```yaml
   *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   tokenExpiresIn: "15552000s"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.RegenerateSCIMToken
   */
  regenerateSCIMToken: {
    methodKind: "unary";
    input: typeof RegenerateSCIMTokenRequestSchema;
    output: typeof RegenerateSCIMTokenResponseSchema;
  },
  /**
   * Initiates domain verification process to enable organization features.
   *
   * Use this method to:
   * - Start domain ownership verification
   * - Enable automatic team joining
   * - Set up SSO restrictions
   * - Configure email-based policies
   *
   * ### Examples
   *
   * - Verify primary domain:
   *
   *   Starts verification for main company domain.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   domain: "acme-corp.com"
   *   ```
   *
   * - Verify subsidiary domain:
   *
   *   Adds verification for additional company domain.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   domain: "acme-subsidiary.com"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateDomainVerification
   */
  createDomainVerification: {
    methodKind: "unary";
    input: typeof CreateDomainVerificationRequestSchema;
    output: typeof CreateDomainVerificationResponseSchema;
  },
  /**
   * Retrieves the status of a domain verification request.
   *
   * Use this method to:
   * - Check verification progress
   * - View verification requirements
   * - Monitor domain status
   *
   * ### Examples
   *
   * - Get verification status:
   *
   *   Checks the current state of a domain verification.
   *
   *   ```yaml
   *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetDomainVerification
   */
  getDomainVerification: {
    methodKind: "unary";
    input: typeof GetDomainVerificationRequestSchema;
    output: typeof GetDomainVerificationResponseSchema;
  },
  /**
   * Lists and monitors domain verification status across an organization.
   *
   * Use this method to:
   * - Track verification progress
   * - View all verified domains
   * - Monitor pending verifications
   * - Audit domain settings
   *
   * ### Examples
   *
   * - List all verifications:
   *
   *   Shows all domain verifications regardless of status.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List with pagination:
   *
   *   Retrieves next page of verifications.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *     token: "next-page-token-from-previous-response"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.ListDomainVerifications
   */
  listDomainVerifications: {
    methodKind: "unary";
    input: typeof ListDomainVerificationsRequestSchema;
    output: typeof ListDomainVerificationsResponseSchema;
  },
  /**
   * Verifies domain ownership for an organization.
   *
   * Use this method to:
   * - Complete domain verification process
   * - Enable domain-based features
   * - Validate DNS configuration
   *
   * ### Examples
   *
   * - Verify domain ownership:
   *
   *   Verifies ownership after DNS records are configured.
   *
   *   ```yaml
   *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.VerifyDomain
   */
  verifyDomain: {
    methodKind: "unary";
    input: typeof VerifyDomainRequestSchema;
    output: typeof VerifyDomainResponseSchema;
  },
  /**
   * Removes a domain verification request.
   *
   * Use this method to:
   * - Cancel pending verifications
   * - Remove verified domains
   * - Clean up unused domain records
   *
   * ### Examples
   *
   * - Delete verification:
   *
   *   Removes a domain verification request.
   *
   *   ```yaml
   *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.DeleteDomainVerification
   */
  deleteDomainVerification: {
    methodKind: "unary";
    input: typeof DeleteDomainVerificationRequestSchema;
    output: typeof DeleteDomainVerificationResponseSchema;
  },
  /**
   * Gets organization policy settings by organization ID.
   *
   * Use this method to:
   * - Retrieve current policy settings for an organization
   * - View resource limits and restrictions
   * - Check allowed editors and other configurations
   *
   * ### Examples
   *
   * - Get organization policies:
   *
   *   Retrieves policy settings for a specific organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationPolicies
   */
  getOrganizationPolicies: {
    methodKind: "unary";
    input: typeof GetOrganizationPoliciesRequestSchema;
    output: typeof GetOrganizationPoliciesResponseSchema;
  },
  /**
   * Updates organization policy settings.
   *
   * Use this method to:
   * - Configure editor restrictions
   * - Set environment resource limits
   * - Define project creation permissions
   * - Customize default configurations
   *
   * ### Examples
   *
   * - Update editor policies:
   *
   *   Restricts available editors and sets a default.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   allowedEditorIds:
   *     - "vscode"
   *     - "jetbrains"
   *   defaultEditorId: "vscode"
   *   ```
   *
   * - Set environment limits:
   *
   *   Configures limits for environment usage.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   maximumEnvironmentTimeout: "3600s"
   *   maximumRunningEnvironmentsPerUser: "5"
   *   maximumEnvironmentsPerUser: "20"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateOrganizationPolicies
   */
  updateOrganizationPolicies: {
    methodKind: "unary";
    input: typeof UpdateOrganizationPoliciesRequestSchema;
    output: typeof UpdateOrganizationPoliciesResponseSchema;
  },
  /**
   * Retrieves the OIDC token configuration for an organization.
   *
   * Use this method to:
   * - Check which OIDC token version is active (V2 or V3)
   * - View extra sub claim fields (V3 only)
   *
   * ### Examples
   *
   * - Get OIDC config:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetOIDCConfig
   */
  getOIDCConfig: {
    methodKind: "unary";
    input: typeof GetOIDCConfigRequestSchema;
    output: typeof GetOIDCConfigResponseSchema;
  },
  /**
   * Updates the OIDC token configuration for an organization.
   *
   * Use this method to:
   * - Switch between OIDC token versions (V2 or V3)
   * - Configure extra sub claim fields (V3 only)
   *
   * ### Examples
   *
   * - Enable V3 tokens with extra sub fields:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   oidcConfig:
   *     v3:
   *       extraSubFields:
   *         - "environment_id"
   *         - "creator_email"
   *   ```
   *
   * - Switch back to V2 tokens:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   oidcConfig:
   *     v2: {}
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateOIDCConfig
   */
  updateOIDCConfig: {
    methodKind: "unary";
    input: typeof UpdateOIDCConfigRequestSchema;
    output: typeof UpdateOIDCConfigResponseSchema;
  },
  /**
   * Retrieves the announcement banner configuration for an organization.
   *
   * Use this method to fetch the current announcement banner settings.
   * All organization members can read the banner configuration.
   *
   * ### Examples
   *
   * - Get announcement banner:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetAnnouncementBanner
   */
  getAnnouncementBanner: {
    methodKind: "unary";
    input: typeof GetAnnouncementBannerRequestSchema;
    output: typeof GetAnnouncementBannerResponseSchema;
  },
  /**
   * Updates the announcement banner configuration for an organization.
   *
   * Use this method to configure the announcement banner displayed to all users.
   * Only organization admins can update the banner. Requires Enterprise tier.
   *
   * ### Examples
   *
   * - Enable announcement banner:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   message: "Scheduled maintenance on Saturday 10pm-2am UTC"
   *   enabled: true
   *   ```
   *
   * - Disable announcement banner:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   enabled: false
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateAnnouncementBanner
   */
  updateAnnouncementBanner: {
    methodKind: "unary";
    input: typeof UpdateAnnouncementBannerRequestSchema;
    output: typeof UpdateAnnouncementBannerResponseSchema;
  },
  /**
   * Sets the tier of an organization.
   *
   * Use this method to:
   * - Change an organization's tier between free, core, and enterprise
   *
   * ### Examples
   *
   * - Set organization tier:
   *
   *   Changes organization tier to enterprise.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   tier: ORGANIZATION_TIER_ENTERPRISE
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.SetTier
   */
  setTier: {
    methodKind: "unary";
    input: typeof SetTierRequestSchema;
    output: typeof SetTierResponseSchema;
  },
  /**
   * Sets the Stripe customer ID for an organization's billing configuration.
   *
   * Use this method to associate an existing Stripe customer with an organization
   * during enterprise customer onboarding.
   *
   * ### Examples
   *
   * Deprecated: Use BillingService.SetupEnterpriseBilling instead.
   * This method is no longer functional and will return an Unimplemented error.
   *
   * - Set Stripe customer ID:
   *
   *   Associates a Stripe customer with an organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   stripeCustomerId: "cus_ABC123"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.SetStripeCustomerID
   * @deprecated
   */
  setStripeCustomerID: {
    methodKind: "unary";
    input: typeof SetStripeCustomerIDRequestSchema;
    output: typeof SetStripeCustomerIDResponseSchema;
  },
  /**
   * Creates a custom domain configuration for an organization.
   *
   * Use this method to configure custom domains for organization workspaces
   *
   * ### Examples
   *
   * - Configure AWS custom domain:
   *
   *   Sets up a custom domain with AWS provider.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   domainName: "workspaces.acme-corp.com"
   *   provider: CUSTOM_DOMAIN_PROVIDER_AWS
   *   awsAccountId: "123456789012"
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.OrganizationService.CreateCustomDomain
   */
  createCustomDomain: {
    methodKind: "unary";
    input: typeof CreateCustomDomainRequestSchema;
    output: typeof CreateCustomDomainResponseSchema;
  },
  /**
   * Retrieves a specific custom domain configuration.
   *
   * Use this method to view custom domain details
   *
   * ### Examples
   *
   * - Get custom domain configuration:
   *
   *   Retrieves details of a specific custom domain.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.GetCustomDomain
   */
  getCustomDomain: {
    methodKind: "unary";
    input: typeof GetCustomDomainRequestSchema;
    output: typeof GetCustomDomainResponseSchema;
  },
  /**
   * Updates custom domain configuration settings.
   *
   * Use this method to:
   * - Update cloud provider settings
   * - Change AWS account ID
   * - Modify domain configuration
   *
   * ### Examples
   *
   * - Update AWS account ID:
   *
   *   Changes the AWS account ID for the custom domain.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   domainName: "workspaces.acme-corp.com"
   *   awsAccountId: "987654321098"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.UpdateCustomDomain
   */
  updateCustomDomain: {
    methodKind: "unary";
    input: typeof UpdateCustomDomainRequestSchema;
    output: typeof UpdateCustomDomainResponseSchema;
  },
  /**
   * Removes a custom domain configuration from an organization.
   *
   * Use this method to:
   * - Disable custom domain functionality
   * - Remove outdated configurations
   * - Clean up unused domains
   *
   * ### Examples
   *
   * - Delete custom domain configuration:
   *
   *   Removes a specific custom domain configuration.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.OrganizationService.DeleteCustomDomain
   */
  deleteCustomDomain: {
    methodKind: "unary";
    input: typeof DeleteCustomDomainRequestSchema;
    output: typeof DeleteCustomDomainResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_organization, 0);

